//English
export const language = {
    //2020-10-26-ljm增加 弹窗提示以及翻译
    meassage:{
        leanMore:'Learn more',
        skip:'Skip',
        activate:'Activate',
        emailSend: 'Email sent!',
        },
leftBanner: {
    liteWebsite: 'Website Backup',
    liteClone: 'Website Clone',
    liteFile: 'Lite File',
    logoSlogan: 'The Go-To Choice for Cloud Transfer',
    cloudEscription: 'MultCloud – The Go-To Choice for Cloud-to-Cloud Data Transfer',
    commonTools: 'Common Tools',
    cloudDrives: 'My Cloud Drives',
    onlineServices: 'My Online Services',
    inviteFriends: 'Invite friends',
    taskList: 'Task List',
    cloudTransfer: 'Cloud Transfer',
    cloudSync: 'Cloud Sync',
    cloudBackup:'Cloud Backup',
    btLink: 'Remote Upload',
    teamTransfer:'Team Transfer',
    shares: 'Shares',
    emailTransfer: 'Email Migration',
    instagramDownload: 'Instagram Downloader',
    videoDownload: 'Video Downloader',
    webDownload: 'Web Image Downloader',
    addCloud: 'Add Cloud',
    addEmail: 'Add Clouds and Emails',
    manageClouds: 'Manage Clouds and Emails',
    manageClouds2: 'Manage Clouds',
    encryption: 'encryption',
    edit: 'Re-add',
    remove: 'Remove',
    createTask: 'Create Task',
    createTaskText: 'You can create the most common tasks here.',
    gotIt: 'Got it',
    bigWriteEncrypt: 'Encryption',
    encryptionText: 'You can setup cloud file encryption here.',
    addCloudText: 'Click here to connect your cloud drive and email to MultCloud.',
    switchTxt: 'Switch to classic MultCloud',
    switchTip:'Switch to Classic MultCloud',
    switchTipDes:'You can switch to classic MultCloud here.',
    new: 'New',
},
common: {
    addCloud: 'Add Cloud',
    addEmail: 'Add Email',
    options: 'Options',
    schedule: 'Schedule',
    ok: 'OK',
    save: 'Save',
    add: 'Add',
    upgradeNow: 'Upgrade Now',
    addWebsite: 'Add Website',
    websiteName: 'Website Name',
    websiteTip: 'Click here to add Website you want to backup.',
    continue: 'Continue',
    overwriteTip: 'If the target website files or databases already exist, this restore will overwrite the existing website files or databases. Do you want to continue?',
    overwriteTip2: 'If the target website files or databases already exist, this clone will overwrite the existing website files or databases. Do you want to continue?',
    from: 'From',
    to: 'To',
    result: 'Result',
    fileProcess: 'Files Processed',
    transferFiles:'Files',
    dataProcess: 'Data Processed',
    startTime: 'Start Time',
    currentRate: 'Current Rate',
    endTime: 'End Time',
    timeRemaining: 'Time Remaining',
    averageRate: 'Average Rate',
    averageRateSpecial: 'Avg.Rate',
    viewFailed: 'click here to view failed files',
    fileSuccess: 'Success in transferring all files',
    size: 'Size',
    path: 'Path',
    setUp: 'Set Up',
    backups: 'Backups',
    restoreTo: 'Restore to',
    restoreNewLocation: 'Restore to New Location',
    executedTimes: 'Executed times',
    sourceDir: 'Source Directory',
    cause: 'Cause',
    retry: 'Re-try',
    retryMin: 'Retry',
    clean: 'Clean',
    properties: 'Properties',
    copy: 'Copy',
    move: 'Move',
    multiSelect: 'Multi-select',
    close: 'close',
    copyTo: 'Copy to',
    tranTo: 'Transfer to',
    syncWith: 'Sync with',
    backupTo: 'Backup to',
    download: 'Download',
    delete: 'Delete',
    more: 'More',
    preview: 'Preview',
    share: 'Share',
    shareWith: 'Share with MultCloud',
    shareTransfer: 'Create a Transfer',
    encrypt: 'Encrypt',
    encryptFile: 'Encrypt File Only',
    encryptFileName: 'Encrypt File and Name',
    decrypt: 'Decrypt',
    decryptFile: 'Decrypt File Only',
    decryptFileName: 'Decrypt File and Name',
    onedriveBusinessContentNote: 'Note',
    oneDrive4BusinessContent: 'If you\'re an admin and have assigned a Microsoft 365 license to a user but receive an "Access denied" error when trying to access the user\'s folder via MultCloud, please try the following steps:',
    oneDrive4BusinessTips1: `Go to "<a href="https://admin.microsoft.com/" target="_blank" class='add-onedrivebuiness-link'>Admin</a>". Select "Users" > "Active Users" tab > Select the "Manage Product License" option.`,
    oneDrive4BusinessTips2: 'Go to the "OneDrive" tab and click "Create Link to File". Then, back to MultCloud and try to access the account again.',
    oneDrive4BusinessStep1: 'Step1',
    oneDrive4BusinessStep2: 'Step2',
    upStep: 'Previous',
    nextStep: 'Next',
    complete: 'Finish',
    cut: 'Cut',
    viewDetails: 'View Details',
    toOfficialSite: 'Official Site',
    btLinkTask: 'Remote Task',
    fileName: 'File Name',
    itemsSelected: 'items selected',
    dateModified: 'Date Modified',
    rename: 'Rename',
    paste: 'Paste',
    btLink: 'Remote Upload',
    load: 'Loading',
    status: 'Status',
    operate: 'Operate',
    failure: 'Failure',
    link: 'Link',
    cleanList: 'Clean List',
    type: 'Type',
    account: 'Account',
    name: 'Name',
    selectFailedFile: 'Please select failed file',
    transferring: 'Transferring',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    done: 'Done',
    no: 'No',
    yes: 'Yes',
    attention: 'Attention',
    cancel: 'Cancel',
    unsubscribe: 'Unsubscribe',
    reactivate: 'Reactivate it',
    sureCleanAll: 'Are you sure to clear all completed tasks?',
    failedFiles: 'Failed Files',
    minTo: 'to',
    retryAll: 'Retry all',
    viewProgress: 'View Progress',
    taskNotRun: 'This task is not running.',
    success: 'Success',
    canceled: 'Canceled',
    patial: 'Partial Success',
    syncDetails: 'Sync Details',
    width: 'Width',
    sync: 'Sync',
    targetCloud: 'Target Cloud Drives',
    running: 'Running',
    preparing: 'Preparing',
    waiting: 'Waiting',
    target: 'Target',
    noVip: 'You now have a maximum of 2 files transferring simultaneously. Upgrade to any premium service to have a maximum of 10!',
    vipThanks: 'Thank you for subscribing our service. You now have a Maximum of 10 files transferring simultaneously.',
    emailAccount: 'Email Account',
    with: 'With',
    syncing: 'Syncing',
    selectAll: 'Select All',
    date: 'Date',
    failed: 'Failed',
    skip: 'Skip',
    replace: 'Replace',
    ready: 'Ready',
    connecting: 'Connecting',
    account: 'Account',
    selectNull: 'Please select a target directory.',
    selectOther: 'This directory cannot be selected for pasting files, you can select its subdirectories or other directories.',
    editShare: 'Edit Share',
    toSource: 'To Source',
    copyLink: 'Copy Link',
    toShare: 'To Share',
    report: 'Report',
    expand: 'Expand',
    shrink: 'Shrink',
    filterHolder:'Enter a file extension here.Eg mp4',
    countFiles:'Counting files',
    upgradeMulti:'Upgrade to Multithread',
     team: 'Team Files',
     loadData:'Loading data, please wait',
     getAccountInfo:'Can\'t get the account information, please re-login and try again.',
    loadingData:'Loading data ...',
    failedEmptyTip: 'Failed to load failed files. Please contact <a href="mailto:support@multcloud.com">support@multcloud.com</a> for further help.',
    runNow:'Run Now',
    emailFilter: 'Email Filter',
    me: "Me",
    reset: "Reset",
    apply: "Apply",
    failureReason: 'Failure Reason',
    countingFilesTip: 'Calculating({num}files)',
    taskName: 'Task Name',
    frequency: 'Frequency:',
    canceling: 'Cancelling ... ',
},
rightTopBanner: {
    navTransfer: 'Cloud-to-cloud Transfer',
    navInstagram: 'Instagram Downloader',
    navVideo: 'Video Downloader',
    navWeb: 'Web Image Downloader',
    traffic: 'Traffic',
    upgrade: 'Upgrade',
    settings: 'Settings',
    changePassword: 'Change Password',
    changeName: 'Change Name',
    bindEmail: 'Bind Email',
    deleteAccount: 'Delete Account',
    language: 'Language',
    help: 'Help',
    notifications: 'Notifications',
    notification: 'Updates',
    subAccounts: 'Sub-accounts',
    logout: 'Logout',
    tutorials: 'Tutorials',
    contact: 'Contact',
    limitsClouds: 'Limits of Clouds',
    faq: 'FAQ',
    unlimited:'Unlimited',
    purTraffic: 'Purchase Traffic',
    unlimitedPlan: 'Unlimited Plan',
    monthlyUnlimitedPlan: 'Monthly Unlimited Plan',
    rememberOriginal: 'Please remember your original username:',
    andPassword: 'and password',
    bindEmailOpen: 'Best to <span style="color:#8a96e3;cursor:pointer;" id="bindEmailOpen">bind your email address and change the default password </span> for security and convenience.',
    lifeSwitchTip: 'With LIFETIME UNLIMITED service, you can transfer files bewteen clouds with no traffic limits.',
    lifeTimePlan: 'Lifetime Unlimited',
    browserPrompt:'For better user experience, we suggest to use Google Chrome.',
    lifeTimeNotice:'You\'re a MultCloud Lifetime Unlimited user.',
    subAccount:"Sub Account",
    bindMailTips:"Please bind your Email to unlock cloud file transferring and make the most out of MultCloud.",
    bind:"Bind",
},
popup: {
    userStarPopup: {
        starDesc: "How's your experience so far?",
        ok: "OK",
        thankYou: "Thank You!",
        thankYouDesc: "If you could spare a moment to share your real and honest experience using our product, it would help keep our small team motivated to make MultCloud even better.",
        reviewStart: "Review us on",
        reviewEnd: "",
        feedbackTitle: "How can we improve?",
        feedbackDesc: "Add your feedback",
        feedbackBtn: "Submit",
        feedbackYes: "Thank you for the feedback.",
        feedbackNo: "Please enter your feedback.",
    },
    addCloudPopup: {
        endpointOptional:'Endpoint(optional)',
        regionOptional:'Region(optional)',
        bucketOptional:'Bucket(optional)',
        //2020.09.23 添加NAS云盘
        addNas: 'ADD NAS',
        addNasFtpDes: `Connect NAS via FTP. Don’t know how to set up FTP for NAS? Please <a href="https://www.multcloud.com/help/enable-ftp-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>click here</a>`,
        addNasWebDes: `Connect NAS via WebDAV. Don’t know how to set up WebDAV for NAS? Please <a href="https://www.multcloud.com/help/enable-webdav-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>click here</a>`,
        bucketName: 'Bucket Name',
        endpoint: 'Endpoint',
        accessKeyId: 'Access Key ID',
        idriveKeyId: 'Access Key ID',
        secretAccessKey: 'Secret Access Key',
        idriveSecretAccessKey: 'Secret Access Key',
        displayName: 'Display Name',
        addFtp: 'ADD FTP',
        addFtpDes: 'To connect your FTP,MultCloud needs you to enter your authentication details.',
        egnyteTip: `Tips: To get your key and secret, you'll need Egnyte API management ID. If don't have one, you can <a href="https://developers.egnyte.com/member/register" target="_blank" class='add-cloud-link'>register here</a>.`,
        icedriveTip: 'Note:',
        icedriveTip1: `1. Support Icedrive Premium accounts only.`,
        icedriveTip2:`2. Click your Icedrive Username -> 2FA & Access -> WebDAV -> Enable -> Show Key. The Access Key is the password.`,
        iCloudPhotosTip: 'Tips:',
        iCloudPhotosTip1: '1. Before connecting your iCloud Photos to MultCloud, please ensure that "Access     iCloud Data on the Web" is turned on.',
        iCloudPhotosTip1Q: `How to manage web access to your iCloud data：<br><br>On iPhone or iPad<br>1. Open the Settings app.<br>2. Tap your name, then tap iCloud.<br><br>3. Tap to turn off or turn on Access iCloud Data on the Web.<br>
        <br>On Mac<br>1. Choose Apple menu > System Settings.<br>2. Click your name, then click iCloud.<br>3. Click to turn off or turn on Access iCloud Data on the Web.`,
        iCloudPhotosTip2: '2. iCloud Photos supports only the following image formats: jfif, pjpeg, jpeg, pjp,  jpg, HEIC.',
        iCloudDomainTip: 'If your iCloud account belongs to the China region, please make sure to select www.icloud.com.cn in the Domain field.',
        server: 'Server',
        protocol: 'Protocol',
        port: 'Port',
        passive: 'Passive mode',
        passphrase: 'Passphrase',
        explanation: 'To connect to FTP, the prefix should be "ftp://" or prefix is missed.If your FTP port is not default, it  a special port number,such as 21,please use the format to specify the port below:ftp://ftp.myhost.com:21',
        userName: 'Username',
        passWord: 'Password',
        advanced: 'Advanced',
        commFTP: 'Common FTP',
        transMode: 'Transfer mode',
        encoding: 'Encoding',
        path: 'Path(optional)',
        cloudName: 'Cloud Name',
        cloudService: 'Cloud Service',
        addedTime: 'Added Time',
        usedSpace: 'Used Space',
        totalSpace: 'Total Space',
        iCloudUsedSpace: 'iCloud Photos storage',
        iCloudDriveUsedSpace: 'iCloud Drive storage',
        iCloudTotalSpace: 'iCloud total storage',
        iCloudDriveTotalSpace: 'iCloud total storage',
        removeContent: 'Some cloud transfer tasks are based on this cloud. Do you still want to remove it?',
        baiDuTips: 'You can only upload or transfer files to the "全部文件/我的应用数据/MultCloud" directory',
        google_driveTips: 'When transfer files or folders from Google Drive to other, please make sure there are not the same file names under the same directory.',
        mySQLQuestion: 'You need to enter your IP address of MySQL server in the server field, and the default port is 3306 or you should enter your custom port.',
        webDavQuestion: `If you use secure SSL connection then add "https://" prefix to your host or do nothing and the default port is 443, otherwise, the prefix should be "http://" and the default port is 80.
        e.g. https://dav.box.com/dav`,
        egnyteQuestion: 'Log in Engnyte and find your domain in address bar. Please enter the domain in this format: e.g. https://aomeitech.egnyte.com/',
        ownCloudQuestion: 'If you use secure SSL connection then add "https://" prefix to your host or do nothing and the default port is 443, otherwise, the prefix should be "http://" and the default port is 80',
        amazonQuestion: `Visit the page to learn <a href="https://www.multcloud.com/tutorials/s3-key.html" target="_blank" class='add-cloud-link'>how to get Amazon S3 access key id.</a>`,
        boxTips: `Box does not support the transmission of a single file greater than 2GB.`,
        google_drive_sharedWithMeTips:'When you transfer files to folders of Shared With Me drive, please make sure you are authorized with "Upload Permission".',
        gSuiteSharedDriveTips:'When you transfer files to folders of Shared Drive, please make sure you are authorized with "Upload Permission".',
        webDavTips: `1.Please make sure that you have read/write permissions before file operations, otherwise, MultCloud may be unable to transfer files into your WebDav.
        2. Please make sure that there is enough space for your operations. We are temporarily unable to identify its size.`,
        aDriveTips: 'We support Personal Premium and Business accounts but not Personal Basic account at present.',
        yandexTips:  `1.Please make sure that there is enough space for your operations. We are temporarily unable to identify its size.
                      2.If you have enabled app password, please enter the app password in the Password bar above. `,
        googlePhotosTips: `1.The "Photos" directory can only store images, videos and other media files, but not directories.
        2.The "Albums" directory can only store album directories, but not media files.
        3.The "Sharing" directory contains all the albums shared by you or the shared albums you have joined.
        4.Google Photos only supports uploading images, videos and other media files. And when using MultCloud upload function, you can only upload files to the album directories created or shared by MultCloud.
        5.When using MultCloud source share function, You can only share the albums created by MultCloud.
        6.All the untitled albums will be dispalyed as "Untitled".
        7.Currently, The downlaod function is available, but downloding original files is not supported.
        8.Currently, there is no support for cut, delete and rename functions. And you can not use the functions that rely on these operations.`,
        googlePhotosV2Tips: `1.The "Photos" directory can only store images, videos and other media files, but not directories.
        2.The "Albums" directory can only store album directories, but not media files.`,
        evernoteTips: `1. API rate limits. <a href='https://dev.evernote.com/doc/articles/rate_limits.php' target="_blank" class='add-cloud-link'> View details>> </a>
          2. What are the system limits of Evernote? <a href='https://help.evernote.com/hc/en-us/articles/209005247-What-are-the-system-limits-of-Evernote-' target="_blank" class='add-cloud-link'>View details>></a>
          3. You can only upload a file less than 50MB to the note.
          4. Cannot rename or delete the notes content files (. ENML).
          5. Can only copy the notes to notebook.`,
        flickrTips: `1. You can only transfer pictures or videos to Flickr.
        2. Folders can only be transferred to "Albums" directory and there can not be subdirectories under "Albums" directory.
        3. Files can only be transferred to "My Photostream" or "Albums" directory you create.
        4. All your files can be found in "My Photostream" directory.
        5. All files under "Albums" directory are referenced to "My Photostream" directory.`,
        mediafireTips: 'Uploading and downloading empty file is not supported. It may take long to open a folder which contains a lot of files.',
        mySQLTips: `1. Your database needs to be accessible from our IP addresses, which are 209.126.%. You can create a new user through your database or host interface, the MySQL command is as follow:
        <span class='add-mysql-link'>GRANT SHOW DATABASES, SELECT, LOCK TABLES, RELOAD ON *.* TO username@'209.126.%' IDENTIFIED BY 'password';</span>
        2. Your server may needs to add a firewall rule with our IP addresses and accessed port(the default port is 3306) to access your databases normally.`,
        hubiCTips: `1. A hubiC account can only add one time.
        2. You cannot rename and cut files or folders.
        3. It may be a little slow to delete folders with many files.
        4. hubiC does not support the transmission of a single file greater than 5GB.
        5. File names can't exceed 248 characters and folder names are limited to 256 characters.`,
        gSuiteUpTips: `The connection between G Suite and MultCloud is only available for G Suite administrators. To connect G Suite to MultCloud, you need to "DOMAIN INSTALL" our G Suite Marketplace app --- <a href='https://gsuite.google.com/marketplace/search/Cloud%20Transfer%20-%20MultCloud?hl=en' target="_blank" class='add-cloud-link'>"Cloud Transfer - MultCloud"</a> first.`,
        gSuiteTips: `1.You must be a <a href="https://support.google.com/a/answer/2405986?hl=en" target="_blank" class='add-cloud-link'> G Suite administrator</a>.
                    2.How to check if it is an administrator account? First, refer to this link <a href='https://support.google.com/a/answer/2406043' target="_blank" class='add-cloud-link'> https://support.google.com/a/answer/2406043</a>. Second, login your Gsuite account from the link. Third, you can find the results under the "To create a custom role" line.
                    3.The <a href='https://support.google.com/a/answer/60757?hl=en' target="_blank" class='add-cloud-link'>API Access </a> is enabled.
                    4.Before adding this cloud drive, you should install our <a href='https://gsuite.google.com/marketplace?hl=en' target="_blank" class='add-cloud-link'> G Suite Marketplace app </a> "MultCloud for G Suite" first and make sure its <a href='https://admin.google.com/' target="_blank" class='add-cloud-link'> setup </a>  is correct: the status is on and the data access is granted.`,
        hiDriveTips: `1.Please make sure you have an account with WebDAV protocol enabled and read/write permissions before working with files, otherwise MultCloud may not be able to transfer files to your HiDrive.
        2. Please make sure that there is enough space for your operations. We are temporarily unable to identify its size.`,
        backblazeTips: `1.Each bucket name must be at least 6 characters long.
        2.When you create a new application key, the old one will no longer work.
        3.File names cannot start with "/", end with "/", or contain "//".`,
        WEBDETips: `1.Please make sure that you have read/write permissions before file operations, otherwise, MultCloud may be unable to transfer files into your Web.De.
        2. Please make sure that there is enough space for your operations. We are temporarily unable to identify its size.`,
        alfrescoTips: `As a free Alfresco Account, your storage space for network is 10GB and the individual file size limit is 50MB.`,
        cloudMeTips: `1.Please make sure that you have read/write permissions before file operations, otherwise, MultCloud may be unable to transfer files into your CloudMe.
        2. Please make sure that there is enough space for your operations. We are temporarily unable to identify its size.`,
        myDriveTips: `Please make sure that there is enough space for your operations. We are temporarily unable to identify its size.`,
        cubbyTips: `1.Please make sure that you have read/write permissions before file operations, otherwise, MultCloud may be unable to transfer files into your Cubby.
        2. Please make sure that there is enough space for your operations. We are temporarily unable to identify its size.`,
        cloudType: 'Cloud Type',
        notificationTip: `Thank you for using the latest MultCloud, if you have any	problem, feedback to:<a href="mailto:support@multcloud.com">support@multcloud.com</a>,thanks.`,
        notAbleAccess: 'Not Able to Access Google Photos Problem Solved',
        problemNotAccess: 'The problem of not able to access Google Photos has been fixed. If you still cannot access Google Photos, please re-add it to MultCloud.',
        noPrompt: 'No longer prompt next time',
        addFeatures: 'Some new added features below:',
        version: 'Version:',
        releasedOn: 'Released on ',
        newLabel: 'New :',
        improvedLabel: 'Improved :',
        noteLabel: 'Note :',
        tryNewFeatures: 'Try these new features now and elevate your file management experience with MultCloud!',
        okButton: 'OK',
        notif_v885: `<b>Website Backup:</b> Easily back up website files or databases to cloud storage and restore them when needed.<br><b>Website Clone:</b> Easily copy website files or databases to another website.`,
        notif_v884: `Increased the height of the cloud list for easier viewing and management of multiple cloud accounts.`,
        notif_v881: `Improved iCloud authorization with device verification codes, optimized MultCloud Plus features, and restored Facebook quick sign-in.`,
        notif_v880: `Launched MultCloud Plus, a lightweight experience for cloud transfer and selected cloud services with a higher transfer success rate.`,
        notif_v870: `Unsupported Dropbox Paper and Google Drive files are excluded from related tasks; improved SFTP transfer success rate and fixed temporary tasks getting stuck.`,
        notif_v831: `Fixed temporary tasks incorrectly appearing successful and transfer tasks getting stuck in the waiting state.`,
        notif_v830: `Fixed scheduled transfer, sync, and backup tasks failing to run on schedule; added paid-account activation by activation code.`,
        notif_v780: `Added web tools for video and Instagram downloads without installation; improved FTP transfer success rate.`,
        notif_v760: `Files from supported cloud services retain their original dates after synchronization.`,
        notif_v750: `Improved the transfer success rate for Google Photos.`,
        notif_v740: `<b>Online Video Downloader</b>
<div>Download high-quality videos from YouTube, Facebook, X, TikTok, and 1000+ other sites with MultCloud\'s ad-free, cross-platform Online Video Downloader—no installation required.</div>
<b>Try these new features now and elevate your file management experience with MultCloud!</b>`,
        notif_v730: `<b>Web Image Downloader</b>
<div>Effortlessly collect images from any website or Google search by entering a URL or keyword and save them directly to your cloud storage or local device.</div>
<b>Try these new features now and elevate your file management experience with MultCloud!</b>`,
        notif_v720: `<div>We are excited to announce new features and enhancements in MultCloud:</div>
<ol class="imagesaver_versions">
<li><b>Instagram Downloader:</b><div>You can now easily download Instagram content! With the new Instagram Downloader, users can download or upload Instagram Profile Pictures, Posts, Reels, Stories, and Highlights directly to cloud storage or to your local device.</div></li>
<li><div>Video Downloader and Image Downloader feature will also be available soon.</div></li>
</ol>`,
        notif_v710: `<div>We are excited to introduce the new Image Saver feature in MultCloud! Here are the details of the new functionalities:</div>
<ol class="imagesaver_versions">
<li><b>Save Instagram Images and Videos</b>
<ul class="imagesaver_version">
<li type="disc"><b>Multiple Links Support: </b>Save images and videos from 1-3 Instagram links simultaneously.</li>
<li type="disc"><b>Easy Upload and Download: </b>Choose to upload media directly to your cloud storage or download it to your local device.</li>
</ul></li>
<li><b>Save Website Images</b>
<ul class="imagesaver_version">
<li type="disc"><b>Multiple Links Support: </b>Save images from 1-3 website links at once.</li>
<li type="disc"><b>Flexible Storage Options: </b>Upload images directly to your preferred cloud storage or download them locally.</li>
</ul></li>
<li><b>Save Google Search Images</b>
<ul class="imagesaver_version">
<li type="disc"><b>Keyword-Based Search: </b>Enter a keyword to search for images on Google.</li>
<li type="disc"><b>Direct Save: </b>Easily upload search results to your cloud storage or download them to your computer.</li>
</ul></li>
</ol>`,
        notif_v700: `<div>MultCloud now supports 4shared and lDrive e2.</div>`,
        notif_v630: `<div>MultCloud now supports Icedrive.</div>`,
        notif_v620: `<div>Chrome Extensions: MultCloud Save - Save Webpage as PDF.</div>`,
        notif_v550: `<div>MultCloud now supports Outlook.</div>`,
        notif_v530: `<div>MultCloud now supports iCloud Drive.</div>`,
        notif_v520: `<div>MultCloud now supports Gmail.</div>`,
        notif_v500: `<div>MultCloud now supports iCloud Photos.</div>`,
        notif_v490: `<div>Bug fixes on cloud backup and restore.</div>`,
        notif_v487: `<div>SharePoint online storage supported.</div>`,
        notif_v485: `<div>Share Transfer.</div>
<div>With this feature, you can deliver large files to anyone easily.</div>
<b>Quick Guide :</b>
<div>1.Right click on the file you\'d like to send (in order to select the file, please add the cloud where the file exists to Multcloud first).</div>
<div>2.Navigate to "Share" and select "Create a Transfer".</div>`,
        notif_v482: `<div>Wasabi Cloud Added.</div>
<div>Wasabi users can now connect Wasabi to MultCloud.</div>`,
        notif_v480: `<div>Team Transfer.</div>
<div>Easily to migrate business clouds from one tenant to another. Google Workspace (and Shared Drive), OneDrive for Business, Dropbox Business, Box for Business supported.</div>`,
        notif_v470: `<div>Cloud-to-cloud backup and restore feature added.</div>`,
        notif_v468: `<div>All clouds are supported for Real-time Sync.</div>
<b>Improved :</b>
<div>UI improved on sharing page.</div>`,
        notif_v467: `<div>Cloud-to-cloud sync tasks now support real time sync.</div>
<b>Improved :</b>
<div>Speed improvements for new created transfer and sync tasks.</div>`,
        notif_v465: `<div>1.Released new UI.</div>
<div>2.Supported uploading torrent to cloud.</div>`,
        notif_v457: `<div>1.Added NAS.</div>`,
        notif_v456: `<div>1.Fixed the problem that Google Photos could not be accessed.</div>`,
        notif_v455: `<div>1.Improve the function of sharing MultCloud for free traffic.</div>`,
        notif_v454: `<div>1.Add Multi-Source transfer function.</div>
<div>2.Add Online File Encryption and Decryption.</div>
<div>3.Add Filename Encryption option to File Encryption function.</div>`,
        notif_v453: `<div>1.Optimize Dropbox for Business cloud.</div>`,
        notif_v452: `<div>1.New premium feature: File Uploading Encryption.</div>`,
        notif_v451: `<div>1.Improvements to MultCloud transport server.</div>
<div>2.Free and premium plan updated.</div>`,
        notif_v450: `<div>1.Add recycle bin for some clouds.</div>
<div>2.Modify some interfaces of our website.</div>
<div>3.Optimize some functions.</div>`,
        notif_v444: `<div>1.Add Google Photos and Put.io.</div>`,
        notif_v443: `<div>1.Add One-way Multi-target Sync function.</div>`,
        notif_v442: `<div>1.Add Backblaze.</div>`,
        notif_v441: `<div>1.Add Google Drive for G Suite.</div>`,
        notif_v440: `<div>1.Add Sub-Accounts Management.</div>
<div>2.Improve Google cloud drive.</div>
<div>3.Fix some cloud drive bugs.</div>`,
        notif_v431: `<div>1.Improve OneDrive for Business authorization function and solve the problem that some users can not add this cloud.</div>
<b>Note :</b>
<div>Please re-add your OneDrive for Business cloud and transfer tasks for users that have added this cloud, sorry for the inconvenience.</div>`,
        notif_v430: `<div>1.Added support for pCloud drive.</div>
<div>2.Fix some cloud drive bugs.</div>`,
        notif_v420: `<div>1.Multilanguage adds German and traditional Chinese.</div>
<div>2.Improve Dropbox cloud drive.</div>
<div>3.Improve share feature and add upload & new folder actions in share page.</div>`,
        notif_v410: `<div>1.Add points system.</div>
<div>2.Add history-error view feature.</div>
<div>3.Add manual retry button when transfer fails.</div>
<div>4.Improve search, share, transfer progress features.</div>`,
        notif_v400: `<div>1.Add Cloud Synchronization function, include one -way sync,two-way sync and so on.</div>
<div>2.Added support for OneDrive for Business, Dropbox for Business and Egnyte cloud drives.</div>
<div>3.Improve Share function.</div>
<div>4.Improve UI.</div>
<div>5.Fix transfer bugs.</div>`,
        notif_v380: `<div>1.Upgrade share function, add folder share, share management, save share, transfer share functions.</div>
<div>2.Add "Upload URL" option in upload function.</div>
<div>3.Fix some cloud drive bugs.</div>
<div>4.Remove Copy cloud drive.</div>`,
        notif_v370: `<div>1.Add mega and Evernote cloud drives.</div>
<div>2.Add preview support of text files, such as txt, html, js.</div>
<div>3.Optimize the schedule tasks.</div>
<div>4.Fix the bug of transfering Google documents between Google Drives to keep file types consistent.</div>
<div>5.Amazon S3 support that transfering a singal file greater than 5 Gb.</div>`,
        notif_v360: `<div>1.Add hubiC cloud drive.</div>
<div>2.Add"Experience without signing up" function for quick experience.</div>
<div>3.Add "Go to official site" function for some cloud drives.</div>
<div>4.Fix transmission bugs of OneDrive and Google Drive.</div>`,
        notif_v350: `<div>1.Improve the speed of cross-cloud transmission for VIP users.</div>
<div>2.Add MySQL backup and Flickr cloud drive.</div>
<div>3.Fix some bugs of schedule transfer.</div>
<div>4.Fix the bug that can not list files of FTP and WebDav.</div>`,
        notif_v340: `<div>1.Add MediaFire to MultCloud.</div>
<div>2.Add OwnCloud to MultCloud.</div>
<div>3.Modify the scheduled file transfer.</div>`,
        notif_v330: `<div>1.Add Alfreco to MultCloud.</div>
<div>2.Add aDrive to MultCloud.</div>
<div>3.Modify the break exception for transmission across the different clouds.</div>`,
        notif_v320: `<div>1.Added the "replacement" option.</div>
<div>2.Upgrade OneDrive API, and remove some limits.</div>
<div>3.Modified the bug of amazon cloud drive.</div>
<div>4.Optimize transmission environment.</div>`,
        notif_v310: `<div>1.Support Amazon cloud drive.</div>
<div>2.Support replacing or skipping some files during file transfer.</div>
<div>3.Enhance SFTP service: Support logging in with Private key.</div>
<div>4.Optimize transfer function.</div>
<div>5.Fixed some cloud drive bugs.</div>`,
        notif_v300: `<div>1.Add new functions as Transfer and Task Manager.</div>
<div>2.Support setting of Scheduled Transfer and File Filter.</div>
<div>3.Support notifying by emailing automatically after transferring.</div>
<div>4.Support re-edit the accounts and view the properties of cloud drives.</div>
<div>5.Adjust and optimize some UIs.</div>
<div>6.Enhance the stability and speed of transfer by optimizing the network environment.</div>
<div>7.Fixed some bugs.</div>`,
        notif_v231: `<div>1.Remove the "background" button, and all the transmission tasks will be set to background as default.</div>
<div>2.Fixed some bugs.</div>`,
        notif_v230: `<div>1.Add the function of background transmission.</div>
<div>2.Improve the transmission ability.</div>
<div>3.Add the function of showing the sizes of cloud drives.</div>`,
        notif_v222: `<div>1.Add the function for displaying a right-click menu for tablets, mobile devices.</div>
<div>2.Modify the exceptions about register, find password. Also allows you to skip activation for using MultCloud.</div>
<div>3.Modify the exception that it\'s unable to add the server address which begins with http for WebDav.</div>`,
        notif_v221: `<div>1.Modify the exceptions about list,search,copy files of Google Drive.</div>`,
        notif_v220: `<div>1.Modify the bulk transmission exceptions for the higher transmission stability.</div>
<div>2.Add the function that scanning the details of transmission progress.</div>`,
        notif_v210: `<div>1.Modify the problem that file lists display incompletely.</div>
<div>2.Modify the exceptions about file upload,download and transmission in FTP.</div>
<div>3.Modify the break exception for transmission across the different clouds.</div>
<div>4.Modify the UI of adding FTP and WebDav.</div>
<div>5.Add some notes for each cloud drive.</div>`,
        notif_v200: `<div>1.Add FTP to MultCloud.</div>
<div>2.Add WebDav to MultCloud.</div>
<div>3.Add the menu option:"Copy to".</div>
<div>4.Login with Google and Facebook Account.</div>
<div>5.Improve user-interface to more easy-to-use.</div>
<div>6.Some bug fixes.</div>
<div>7.Support Cubby, MyDrive, Web.de, Yandex, CloudMe, HiDrive, Copy and BaiDu.</div>`,
        applicationKey: 'applicationKey',
        keyID: 'keyID',
        privateKey: 'Private key file for authentication (optional)',
        privateKey2: 'Private key',
        FTPTips:`1.Please make sure that you have read/write permissions before file operations, otherwise, MultCloud may be unable to transfer files into your FTP.
        2. Please make sure that there is enough space for your operations. We are temporarily unable to identify its size.
        3. If you are unable to access your FTP, please add 209.126.103.1/19 and 207.38.89.1/24 into the firewall whitelist.`,
        //2021-10-14
        specialDropBoxBottom:`If you would like to access your personal cloud, please click on "Access Personal Cloud".`,
        specialDropBox:`If you're a Dropbox Business admin and would like to access all accounts of your organization, please click on "Access Organization".`,
        accessOrganization:'Access Organization',
        accessPersonalCloud:'Access Personal Cloud',
        specialBoxBusiness:`If you're a box for Business admin and would like to access all accounts of your organization, please click on "Access Organization".`,
        specialgSuite:`If you're a <a href='https://support.google.com/a/answer/2405986?hl=en' target="_blank" class='add-cloud-link'> Google Workspace admin </a> and would like to access all accounts of your organization, please "Admin Install" our Google Workspace Marketplace app --- "<a href="https://gsuite.google.com/marketplace/app/cloud_transfer_multcloud/72136911391?hl=en" target="_blank" class='add-cloud-link'>Cloud Transfer – MultCloud</a>" first. And then click on "Access Organization".`,
        specialOnedrive:`If you're an OneDrive for Business admin and would like to access all accounts of your organization, please click on "Access Organization".`,
        iCloudPhotosTips:'MultCloud doesn\'t support non-email Apple ID for now.',
        appleId: 'Apple ID',
        addICloudPhotos: 'Add iCloud Photos',
        addICloudDrive: 'Add iCloud Drive',
        fourShared: `Note: 4shared authorization is valid for<span style="color: red"> 2 hours.</span> Please Re-add 4shared and manually execute your tasks after it expires.`,
        fourSharedTips: `Note: 4shared authorization is valid for 2 hours. Please Re-add 4shared and manually execute your tasks after it expires.`,
    },
    cloudExploerPopup: {
        googlePhotosV2Tips: 'Tips for Google Photos',
        googlePhotosV2TipsDesc: 'Google has updated the Google Photos API as of May 7, 2025. To accommodate these changes, we need to implement the following updates:',
        googlePhotosV2Tips1: 'The "Albums" folder will now only display albums created by MultCloud.',
        googlePhotosV2Tips2: 'The "Photos" folder will now only display images uploaded via MultCloud.',
        googlePhotosV2Tips3: 'To transfer images from Google Photos to other Cloud services, please click the "Add More Photos" button and grant MultCloud access to the images you wish to transfer.',
        googlePhotosV2Tips4: 'To transfer images from other cloud services to Google Photos, please note that only folders can be transferred to the "Albums" folder, and only individual images can be transferred to the "Photos" folder.',
        googlePhotosV2TipsShow: 'Don\'t show this again',
        googlePhotosV2AddMore: 'Add More Photos',
        googlePhotosV2AddMoreTips: 'Click here to add your images you\'d like to add to MultCloud.',
        googlePhotosV2FolderName: 'Folder Name',
        googlePhotosV2FolderNameInput: 'Enter a name for the folder where the images will be saved',
        googlePhotosV2NotSelect: 'You haven\'t added any photo yet. Click "Add More Photos" to add images to MultCloud',
        googlePhotosV2SelectAlbums: 'You can only save folders to "Albums"',
        googlePhotosV2SelectAlbum: 'You can only save images and videos to this folder',
        googlePhotosV2SelectPhotos: 'You can only save images and videos to "Photos"',
        googlePhotosV2SelectSession: 'This folder cannot be selected as the target. Please select the "Albums" or "Photos" folder instead.',
        deleteContentEver: 'Are you sure you\'d like to delete the selected items permanently?<br>Once deleted, it cannot be restored from the Trash.',
        deleteContent: 'Are you sure you\'d like to delete the selected items?',
        deleteConfirm: 'Confirm File Deletion?',
        deleteAction: 'This action cannot be undone. The file will be permanently deleted.',
        deleteDeletion: 'Please type the file name to confirm deletion:',
        deleteDeletionOK: 'Please enter the correct file name to confirm deletion',
        detailedProgress: 'Detailed Progress',
        highSpeed: 'High speed search supports the following cloud drives',
        takeMoreTime: 'It may take more time with the following cloud drives',
        enterKeyWord: 'Enter the key word',
        highSpeedSearch: 'High Speed search',
        normalSearch: 'Normal Search',
        shareWithOthers: 'Share with others',
        inviteByEmail: 'Invite people by email',
        pleaseEnterEmail: 'Please enter Emails and seperate them with comma',
        addMessage: 'Add a message(Optional)',
        shareTo: 'Share to',
        noLink: 'No link created yet',
        createShare: 'Create Share',
        cancelAllTask: 'Are you sure you want to cancel all tasks?',
        //2020/8/7-xth
        shareEmailTitle: 'Send link via Email',
        // shareCommunityTitleLong: 'Title should be less than 128 characters',
        // shareCommunityDesLong: 'Description should be less than 256 characters',
        shareNotSupportSource: 'This cloud service doesn\'t support this feature, please try another sharing option',
        shareSendEmail: 'Send Email',
        generateLinkSuccess: 'Sharing Link created',
        generateLinkFail: 'Failed to create sharing link',
        emailSentSuccessful: 'Emails sent',
        emailSentNull: 'You have not yet entered an Email',
        emailSentNotice: 'Please enter a correct Email',
        linkCopySuccessful: 'Link copied!',
        sharePrivateLink: 'Private sharing link: ',
        sharePrivatePassword: ' View password: ',
        cancelMyShareTask: 'Are you sure to cancel the share? This link will no longer work for anyone who has it.',
        cancelMyShareOk: 'Yes, cancel it',
        cancelMyShareNot: 'No, I’ll keep it',
        emailArrayToLong50: 'You can send 50 emails at a time.',
        shareOnEmail: 'Send link via Email',
        shareOnFacebook: 'Share on Facebook',
        shareOnTwitter: 'Share on Twitter',
        shareOnTumblr: 'Share on Tumblr',
        shareOnPinterest: 'Share on Pinterest',
        shareOnLinkedIn: 'Share on LinkedIn',
        ceateShareError: 'Failed to create the share, please check your network.'
    },
    cloudTransferPopup: {
        pleaSelect: 'Please Select',
        schedule: 'Schedule',
        //后又新增的
        checkScheduled: 'Please check the \'Scheduled\' box of this task to activate schedule editor.',
        addValidCloud: 'You must add a valid cloud drive',
         //2020-10-26-ljm增加
         cleanList:'Clean List'
    },
    personalCenter: {
        changePassword: ' Change Password',
        changeName: 'Change Name',
        deleteAccount: ' Delete Account',
        enterPassWord: 'Please enter your password',
        note: 'Note: Please let us know the reason why you leave, we\'ll try our best to correct it.',
        sureDeleteAccount: 'Are you sure you wanna delete this account?',
        unsubscribe: 'Before you delete this account,please unsubscribe MultCloud first.',
        bindEmail: 'Bind Email',
        pleaseSwitch: 'Please switch to classic MultCloud to decrypt the file(s).',
        switchOld: 'Switch to classic',
        pleaseUnsubscribe: 'Please switch to classic MultCloud to unsubscribe your premium service first.',
        deletePremium: 'You\'re about to delete a premium account. Once you\'ve deleted it, you\'ll never be able to get it back. Are you sure you still wanna do this?'
    },
    remoteTaskPopup: {
        addLinkTask: ' Add Link Task',
        validLink: 'Please enter valid link',
        saveCloud: 'Save to Cloud',
        parseFail:'Failed to Parse',
        inadmissibleRequest:'An inadmissible request',
        createBtTask: 'Create BT Task',
        savingPrivateRyun: 'Saving Private Ryun',
        emptySource: 'Please enter a link or upload a torrent file',
        validTorrent: 'The torrent file selected is invalid',
        addTorrent: 'Add Torrent',
        tip: ' You haven\'t selected a cloud to store this file',
        torrentSelected:'Name({num}/{all})',
        urlLinkSupported:"Copy and paste link here, http/https/magnet links supported.\nNote: Don't use MultCloud to download or upload unauthorized, infringing copied materials",
        torrentStore:'Please select a cloud to store the torrent file',
        downloadLink:'Please enter a download link',
        cancelTask:'Cancel Task',
        cancelTaskContent:'Are you sure you want to cancel the task ?',
        parseTaskRunning:'MultCloud is already running a parse process, please go to "Remote Upload" to check it.'
    },
    taskListPopup: {
        deleteTask: 'Delete Task',
        pleaseSelect: 'Please select data before deleting.',
        sureDeleteTask: 'Are you sure you want to delete the task(s)?',
        deleteSingleTask: 'Are you sure you want to delete the task?',
        viewLogs: 'View Logs',
        selectCloud: 'Please select the cloud to save the files'
    },
    upgradeAccountPopup: {
        commonTitle: '5 cloud-to-cloud tasks in parallel',
        commonDes: 'Please upgrade to subscriber and you\'ll be able to run 5 cloud-to-cloud tasks in parallel.',
        upgradeAccount: 'Upgrade Account',
        upgradeHeadTitle:'5 parrallel URLs or torrents',
        upgradeHeadContent:"Free users can have 1 transferring URL or torrent task at a time. Please upgrade to subscriber and you'll have 5 transferring URL or torrent tasks transferring at a time.",
        currentPlan: 'Current Plan',
        insufficientTraffic: 'Insufficient cloud-to-cloud traffic',
        insufficientTrafficDes: 'You have consumed all free data traffic of this month. To get more traffic, please upgrade to premium version.',
        filter: 'File Transfer/Sync Filter',
        filterDes: 'To activate file transfer/sync filter, please upgrade to premium version.',
        modes: 'Advanced Synchronization Modes',
        offlineFree: '1 URL or torrent at a time',
        offlinePremium: '5 parrallel URLs or torrents',
        modesDes: 'Subscribers have Two-way Sync and 7 custom options in One-Way Sync. Incremental Backup Sync supported.',
        doubleRealTime:'Doubled real-time syncing',
        doubleRealTimeSyncDes:'Please upgrade to subscriber and have two real-time sync tasks performing simultaneously.',
        doubledSync: 'Doubled normal syncing',
        doubleSyncDes: 'Please upgrade to subscriber and have two normal tasks performing simultaneously.',
        realTimeSyncing:'Doubled Real-time Syncing',
        norMalSyncing:'Doubled Normal Syncing',
        free: 'Free',
        premium: 'Premium',
        monthTraffic: '5GB Traffic/Month',
        syncMode: '2 Sync Modes',
        scheduled: 'Scheduled Transfer/Sync/Backup',
        scheduledDes: 'To activate schedule feature, please upgrade to premium version.',
        moreTraffic: 'More data traffic as you need',
        moreSyncModes: '8 Sync Modes',
        transferSpeed: 'Quintupled Transfer Speed',
        doubleSync: 'Double-syncing',
        transferServer: 'VIP Transfer Server',
        customerSupport: 'VIP Customer Support',
        syncSupported: 'Two-way Sync and 7 custom options in One-way Sync. Mirror Sync supported.',
        greatlyIncreased: 'There are 10 threads for subscribers instead of two, so the transfer speed is greatly increased.',
        sameTime: 'Subscribers can have 2 real-time sync and 2 normal sync tasks (4 in total) performing simultaneously.',
        normalSametime:'Subscribers can have two Normal sync tasks performing at the same time.',
        automatically: 'Setup a Filter to transfer or sync files with user-defined filename or certain extensions automatically.',
        multipleSync: 'Multiple Sync Targets',
        multipleSyncDes: 'Please upgrade to premium to activate the function of multiple sync targets.',
        freeDes:'Free users have 30GB data traffic in total to transfer or sync data between cloud storage services every month',
        task1: '1 cloud-to-cloud task at a time',
        task5: '5 cloud-to-cloud tasks in parallel',
        emailTitle: 'Insufficient Email Conversions',
        emailDes: 'Free users have 50 Email conversions every month, but it looks like you need more than that. Upgrade to premium and you\'ll have unlimited Email conversions.',
        emailsConversions: '50 Email Conversions/Month',
        emailsUn: 'Unlimited Emails Conversions',
    },
    remindBindEmail:{
        bindExe:'Please bind your Email to execute the task',
        onceBind:' Once you\'ve binded your email, you can also get <span class="gift-flow">30GB</span> additional cloud-to-cloud traffic data traffic!',
        bindEmail:'Please bind your email to activate the core features of MultCloud.',
        coreFeatures:'Multcloud Core Features',
        tourAccount:'Tour Account',
        connectCloud:'Connect Cloud Services to MultCloud',
        viewCloud:'View All Cloud Files via MultCloud',
        uploadFile:'Upload Files to Clouds via MultCloud',
        downloadCloud:'Download Cloud Files via MultCloud',
        syncAndBackup:'Sync and Backup Files between Clouds',
        transferFiles:'Transfer Files from One Cloud to Another',
        failed:'Failed to execute the operation, please try again later.',
    },
    salePagePopup:{
        sOffer:'Special offer for MONTHLY UNLIMITED',
        timeLimited:'Hurry up, time is limited!',
        Hours:'Hours',
        Minutes:'Minutes',
        Seconds:'Seconds',
        monthPrice:'$19.9/Month',
        dataTra:'for UNLIMITED data traffic',
        subscribe:'Subscribe Now',
        features:'Features',
        freePlan:'Free Plan',
        bigSale:'Time-limited big sale',
        discountsto:'Discounts up to',
        off:'25% Off',
        premiumPlan:'Premium Plan',
        transmit:'Traffic for Transmit',
        dataTraffic:'The data traffic for cloud to cloud file transfer and sync.',
        originalPrice:'Original Price',
        nowOnly:'Now Only',
        getDiscount:'Get Discount',
        moreData:'More Data Traffic',
        unlimitedData:'Unlimited Data Traffic',
        syncModes:'Synchronization Modes',
        syncModesDes:'Subscribers have Two-way Sync and 7 custom options in One-way Sync. Mirror Sync supported.',
        scheduledTran:'Scheduled Transfer',
        scheduledTranDes:'With this feature, you can schedule automatic cloud-to-cloud task at a regular interval or for a special timing.',
        transferSpeedDes:'There are 10 threads for subscribers, instead of 2, so the transfer speed is greatly increased',
        fileEncryption:'File Encryption',
        encryptFiles:'Subscribers can encrypt files in cloud drives online and uploading files',
        quarterly:'Quarterly',
        yearly:'Yearly',
        monthGb:'150GB/Monthly',
        monthGbly:'200GB/Monthly',
        monthfourLy:'400GB/Monthly',
        unTr:'Unlimited Traffic',
        nMonth:'/Month',
        tQuarter:'/Quarter',
        eYear:'/Year',
        tOneTime:'One-time',
        //2021-10-09
        premiumFeatures:'150GB traffic with all premium features for a month!',
        unlimitedYear:'Unlimited traffic with all premium features for a year!',
        unlimitedLiftime:'Unlimited traffic with all premium features for lifetime!',

    },
    giveawayActiveSucPopup: {
      headerTitle: "Redemption Successful!",
      headerSubtitle: "Your 3-months Premium activated! Unlock Lifetime Unlimited with an exclusive 80% OFF offer.",
      headerSubtitleYear: "Your 1 Year Premium activated! Unlock Lifetime Unlimited with an exclusive 80% OFF offer.",
      currentPlanBadge: "Activated",
      currentPlanName: "3 Months Premium",
      currentPlanNameYear: "1 Year Premium",
      currentPlanPrice: "$39.99",
      feature1: "3 Months Premium Features",
      feature1Year: "1 Year Premium Features",
      feature2: "{traffic} Data Traffic for 3 months",
      feature2Year: "{traffic} Data Traffic for 1 Year",
      feature3: "Business Day Customer Support",
      upgradePlanBadge: "80% OFF",
      upgradePlanName: "Lifetime Unlimited Premium",
      upgradePlanOriginalPrice: "$628",
      upgradePlanCurrentPrice: "125.6",
      featureUpgrade1: "<b>Lifetime</b> Premium Features",
      featureUpgrade2: "<b>Unlimited</b> Data Traffic",
      featureUpgrade3: "<b>24/7</b> VIP Priority Support",
      featureUpgrade4: "<b>90-Day</b> Refund Guarantee",
      countdownLabel: "Exclusive Upgrade Offer Ends In:",
      btnUpgrade: "Upgrade Now & Save 80%",
      promoText: "to Get Lifetime Unlimited",
      off: "OFF",
    },
    properties: 'Properties',
    general: 'General',
    tips: 'Tips',
    progress: 'Progress',
    limits: 'Limits of Cloud Drives',
    detailed: 'Detailed',
    cancel: 'Cancel All',
    simpleSync: 'Simple Sync',
    onewaySync: 'One-way Sync',
    twowaySync: 'Two-way Sync',
    advancedSync: 'Advanced Sync Modes',
    mirrorSync: 'Mirror Sync',
    moveSync: 'Move Sync',
    cmuSync: 'Cumulative Sync',
    updateSync: 'Update Sync',
    increSync: 'Incremental Sync',
    fullSync: 'Full Backup Sync',
    simpleSyncTip: 'The added, modified and deleted files in the source directory will be replicated to the target directory. However, the added, modified and deleted files in the target directory will not be replicated to the source directory.',
    mirrorSyncTip: 'The files in the source and target directories are always the same (MultCloud will delete the extra files in the target directory).',
    moveSyncTip: 'Once the synchronization is completed, all the files in the source directory will be deleted.',
    cmuSyncTip: 'When deleting the files in the source directory, the same files in the target directory will not be deleted.',
    updateSyncTip: 'All the files in the target directory will be deleted firstly, and then the added and modified files in the source directory will be transferred to the target directory.',
    increSyncTip: 'Each time when you sync files, a subdirectory will be created in the target directory so that the added and modified files in the source directory will be transferred to it.',
    fullSyncTip: 'Each time when you sync files, a subdirectory will be created in the target directory so that all the files in the source directory will be transferred to it.',
    twowaySyncTip: 'The added, modified and deleted files in the source directory will be replicated to the target directory. Likewise, the added, modified and deleted files in the target directory will be replicated to the source directory (Namely, the files in the source and target directories are always the same).',
    clone: 'Clone',
    syncModes: 'Sync Modes',
    email: 'Email',
    filter: 'Filter',
    thread: 'Thread',
    listThread: 'Number of threads iterated',
    runThread: 'Number of executed threads',
    sameName: 'Same name',
    filterInclude: 'Included extensions (e.g., png, doc, mp4)',
    filterExclude: 'Exclude file names (e.g., target, dist, build)',
    newFilterTag: 'New Tag',
    createTaskStatus: 'Created',
    pendingTaskStatus: 'Pending',
    runningTaskStatus: 'Running',
    cancelledTaskStatus: 'Cancelled',
    completedTaskStatus: 'Success',
    failedTaskStatus: 'Failed',
    warnTaskStatus: 'Warning',
    errorTaskStatus: 'Error',
    warning: 'Warning',
    logs: 'Log',
    once: 'Once',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    onlyOnce: 'Run only once at:',
    everyDay: 'Run Everyday at:',
    everyWeek: 'Every week on:',
    at: 'At:',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    runAt: 'Run at:',
    lastDay: 'Last Day',
    chooseAction: 'If the target file already exists. Please choose an action:',
    optionsPrompt: 'If files in the source cloud drive have special character in filename that is not allowed in the target cloud drive, the files will be renamed automatically during the transfer process and a log.html file will be created in the root directory on target cloud drive.',
    sourceNewer: 'Overwrite if source newer.',
    diffSize: 'Overwrite if different size.',
    sourceAll: 'Overwrite if different size or source newer.',
    skipFile: 'Skip the file.',
    skipEmail: 'Skip the email.',
    overWrite: 'Always overwrite.',
    rename: 'Rename',
    overWriteSourceNewer: 'Overwrite if there is an update to the original email.',
    deleteAllSource: 'Delete all source files after transfer is complete.',
    keepFileDate: `Keep file modification date(Supports Dropbox, Google Drive, G Suite).`,
    automaRename: 'Automatically rename the files which contain special characters and generate a script file.',
    sendEmail: 'Send email notification when completing this task.',
    sendMessage: 'Send a test message',
    ignoreFiles: 'Ignore files with these extensions',
    includeFiles: 'Only include files with these extensions',
    selectSync: 'You can select sync mode here:',
    tipsFor: 'Tips for',
    allTasks: 'All Tasks',
    successful: 'Successful',
    unfinished: 'Unfinished',
    transferDetails: 'Transfer Details',
    redit: 'Re-edit',
    publicShare: 'Public Share',
    publicTip: 'Tips:Anyone who gets the link can view the file',
    privateShare: 'Private Share',
    privateTip: 'Tips:Others need to enter password to view the file',
    sourceShare: 'Source Share',
    sourceTip: 'Tips:Create a sharing link of the source cloud drive',
    communityShare: 'Public in MultCloud Community',
    communityTip: 'Tips:Anyone can find and view the file in MultCloud community',
    shareSuccess: 'Create Share Successful',
    copySuccess: 'Copy Successful',
    sharedYet: "This file has been shared already",
    domain: 'Domain',
    code: 'Code',
    resendCode: 'Resend Code',
    key: 'Key',
    secret: 'Secret',
    publicShareEasy: 'Anyone',
    privateShareEasy: 'Private',
    communityShareEasy: 'Public',
    sourceShareEasy: 'Source',
     //2020-10-26-ljm增加
    progressBox:'Progress',
    reportPopup: {
        title: 'Report Share',
        beforeMsgOne: 'Help us understand what’s happening with this share.',
        beforeMsgTwo: 'How would you describe it?',
        typeItems: {
            spam: 'Spam',
            malwareVirus: 'Malware or virus',
            copyrightViolation: 'Copyright violation',
            illegal: 'Illegal content',
            notWorking: 'MultCloud is not working properly',
            other: 'Other inappropriate content',
        },
        nextMsgOne: 'Please fill in the information about this repot.',
        description: 'Description',
        nextMsgTwo: 'Describe what\'s happening with the share.',
        yourEmail: 'Your Email',
        nextMsgThree: 'Please provide your email address and we can reach out if necessary.',
        submit: 'Submit',
        back: 'Back',
        next: 'Next',
        messageNone: 'Please enter the description of this report.',
        emailNone: 'Please enter your contact Email.',
        success: 'Your report has already sent to MultCloud team.'
    },
    subAccountPopup:{
        title: "Sub-accounts management",
        titleMax: "Sub-accounts management",
        titleDes:"Please upgrade to subscriber and you'll be able to create and manage sub-accounts.",
        tabNameUser: "User Mode",
        tabNameItem: "Folder Mode",
        addItemButton: "Assign Folder",
        users: "Users",
        folders: "Folders",
        read: "Read",
        write: "Write",
        questionTxtRead: "Sub-account users can download, preview and copy files to their clouds in this folder.",
        questionTxtWrite: "Sub-account users can create new folders, upload, delete, rename files in this folder.",
        userExist:"The user already exists.",
        userSelf:"You can't add yourself as your sub-account.",
        quickAssign: "Quick Assign",
        quickAdd: "Quick Add",
        allow: "Allow",
        batchAddUserNull: "There is currently no user added.",
        batchAddItemNull: "There is currently no folder added.",
        noUserFromAddItem: "Please add a user first.",
        noItemFromAddUser: "Please add a folder first.",
        addUser: {
            title: "Add User",
            radioCreate: "Create a sub-account",
            radioAdd: "Add an existed MultCloud account",
            createNamePlaceholder: "Create Username",
            createPasswordPlaceholder: "Create Password",
            addNamePlaceholder: "Please enter the existed MultCloud account",
            createNameNone: "Please enter a username.",
            createNameMore: "The username should be less than 20 characters.",
            createPasswordNone: "Please enter a password.",
            createPasswordError: "Please enter a password with 8-16 characters.",
            addUserNameNone: "Please enter an existed MultCloud account.",
            addUserNone: "This account doesn’t exist.",
        },
        addItem: {
            noFolder: "Please select a folder.",
            exist: "You've already added the folder.",
        },
        editUser: {
            title: "Edit Sub-account",
            namePlaceholder: "Enter a username",
        },
        cancel: {
            titleUser: "Delete Sub-account",
            titleItem: "Remove Folder",
            msgUser: "Are you sure to delete this account?",
            msgItem: "Are you sure to remove this folder?",
        },
        unknownError: "Can't find the path, please check if the path exists or re-add the cloud.",
    },
    verifyPopup: {
        verifyTitle: "Verify your identity",
        toRecoveryText: "I don’t have any of these",
        verifyEmailTitle: "Verify your email",
        verifyEmailTips: "We will send a verification code to {email}. To verify that this is your email address, enter it below.",
        verifyPhoneTitle: "Verify your phone number",
        verifyPhoneTips: "We will send a verification code to {phone}. To verify that this is your phone number, enter the last 4 digits including {last}.",
        verifyPhoneText: "Last 4 digits of phone number",
        sendCodeBtn: "Send Code",
        enterCode: "Enter code",
        checkEmailTips: "If {email} matches the alternate  email on your account, we'll send you a code.",
        checkPhoneTips: "If {phone} matches the last 4 digits of the phone number on your account, we'll send you a code.",
        askDevice: "Don't ask me again on this device.",
        verify: "Verify",
        recoveryTitile: "Do you have an account recovery code?",
        recoveryTipsOne: "If you have a recovery code, enter it now. If you don't have one, please contact",
        recoveryTipsTwo: "Your recovery code is 25 characters long and looks like this: XXXXX-XXXXX-XXXXX-XXXXX-XXXXX.",
        recoveryCode: "Recovery Code",
        recoveryCodeBtn: "Use Recovery Code",
        recoveryChangeTitile: "What else can we verify your identity?",
        recoveryEmailChange: "Add an alternate email address",
        recoveryPhoneChange: "Add a phone number",
        enterEmail: "Enter your Email",
        recoveryNextTitle: "Please enter the code we send to {checkCode}",
        recoveryTipsTitle: "For your protection, replacing your security info takes 30 days!",
        recoveryTips1: "Because you turned on two-step verification, you need up-to-date security info to sign in to your account.",
        recoveryTips2: "During the waiting period you will not be able to sign in to sites or services with your account, but will be able to sign in to devices.",
        recoveryTips3: "You can avoid the wait by:",
        recoveryTips4: "Using a trusted device.",
        recoveryTips5: "If you have a device that doesn't require codes, use it now and update your security info.",
        recoveryTips6: "Finding your security info.",
        recoveryTips7: "Any chance it isn't entirely lost? If you can find it, use it now to re-enable your account.",
        recoveryTips8: "The wait makes it harder for someone else to take over your account with a stolen password.",
        recoveryPendTitle: "Your security info change is still pending",
        recoveryPendTips1: "On {data} you requested that your security info be replaced",
        recoveryPendTips2: "Current security info",
        recoveryPendTips3: "Alternate email:",
        recoveryPendTips4: "Phone number:",
        recoveryPendTips5: "New security info",
        recoveryPendTips6: "If you'd like to keep your current security info,",
        recoveryPendTips7: "cancel this request.",
        recoveryCancelTitle: "Here's your new recovery code",
        recoveryCancelTips1: "To help your account secure, you need a new recovery code.",
        recoveryCancelTips2: "If you ever need to recover access to your account, this code will help. You should write it down and store it in a safe place. We strongly recommend that you don't store your recovery code on a device.",
        recoveryCancelTips3: "If you previously had a recovery code, it is no longer valid. Use this new code instead.",
        recoveryCancelTips4: "Your new code is:",
        recoveryCancelSucTitle: "Great! Let's get back into your account!",
        recoveryCancelSucTips1: "The security info update for {old} has been canceled, and now you have full access to your account.",
        recoveryCancelSucTips2: "The contact info used to start the process ({new}) has been removed and won't be used as security info for your account.",
        recoveryCancelSucTips3: "Click \"Next\" to go back to what you were doing.",
        recoveryCancelErrorTitle: "Submitting request",
        recoveryCancelErrorTips: "Your account is still in the waiting period.",
        codeText: "Enter your Phone Number",
        exception: {
            emailTwoStringError: "The correct Email starts with \"{errorCode}\".",
            validEmail: "Please enter a correct Email.",
            phoneLastTwoStringError: "The correct number ends in {errorCode}.",
            validPhone: "You must enter the last 4 digits of phone number.",
            verificationCodeExpired: "The verification code has expired.",
            verificationCodeError: "The verification code is incorrect, please check the code and try again.",
            verificationRecoveryCodeExpired: "The code didn’t work, please check the code and try again.",
            verificationCodeNull: "Please enter a verification code.",
        }
    },
    worldBackupPopup: {
        // title:'World Backup Day',
        title:'MultCloud Special Offer',
        titleTip:'24 Hours Flash Sale',
        timerTitle:'Limited-time offer will end in ...',
        getOffer:'Get Offer',
        tips100Mo:'100GB/Mo traffic data',
        ps100Mo:'Tips: The unused data traffic will accumulate. E.g. You have only consumed 50GB of 100GB in the first month and you\'ll still have 50GB additional data traffic in the next month.',
        tips1200Yr:'1200GB/Yr traffic data',
        ps1200Yr:'Tips: The unused data traffic will accumulate. E.g. You have only consumed 1000GB of 1200GB in the first year and you\'ll still have 200GB additional data traffic in the next year.',
        tips2400Yr:'2400GB/Yr traffic data',
        ps2400Yr:'Tips: The unused data traffic will accumulate. E.g. You have only consumed 2000GB of 2400GB in the first year and you’ll still have 400GB of additional data traffic in the next year.',
        tipsUnYr:'Unlimited/Yr traffic data',
        psUnYr:'Tips: Unlimited data traffic for a year!',
        tipsUnLi:'Unlimited/Lifetime traffic data',
        psUnLi:'Tips: Unlimited data traffic for lifetime!',
        tips1:'10 threads to transfer files',
        tips2:'Scheduled cloud transfer',
        tips3:'24/7/365 priority support',
        ps1:'There are 10 threads for subscribers, while 2 for free users, so the transfer speed is greatly increased.',
        ps2:'Subscribers can schedule automatic cloud to cloud transfer/sync at a regular interval or for a special timing.',
        moPrice:'{price} / Month',
    },
    iosPayTipPopup: {
        title: 'Cancel apple subscription',
        tip: 'Your current {name} is in auto-renewal status (Apple Transaction ID: {id}), please cancel subscription for it and try again.',
        btnTxt: 'How to cancel',
    },
    appRecommendPopup: {
        title: 'The new MultCloud mobile app is available now!',
        tip: 'Download immediately to manage and transfer <br>data across clouds with mobile devices.',
        modileTitle: 'Get the MultCloud Mobile App Now!',
        iosBtnTitle: 'Download on the',
        iosBtnTip: 'App Store',
        androidBtnTitle: 'GET IT ON',
        androidBtnTip: 'Google Play',
        apkBtnTitle: 'Download',
        apkBtnTip: 'MultCloud',
    },
    note: 'Note',
    editCloudNoticPopup: {
        tips: 'The authorization has expired, please re-add the cloud to MultCloud and try again.',
        btnTxt: 'Re-add',
    },
    appleTipsPopup: {
        title: 'Tips',
        tipTitle: 'Tips for iCloud Photos 2-factor auth',
        tip1: 'To connect your iCloud Photos to MultCloud, you need to grant MultCloud server access to your Apple ID. So you may see our server location differs from your actual location during 2-factor auth procedure.',
        tip2: 'And please remember: Your security and privacy is our No.1 priority. MultCloud does not store your data permanently. It might temporarily cache part of the content based on your operations, however, it will be removed  from our server immediately once the operation is done. And connection between your iCloud Photos and MultCloud servers is always done over a secure 256-bit SSL channel.',
        checkTip: 'Don\'t show this again',
    },
    iCloudDriveTips: {
        title: 'Tips',
        tipTitle: 'Tips for iCloud Drive 2-factor auth',
        tip1: 'To connect your iCloud Drive to MultCloud, you need to grant MultCloud server access to your Apple ID. So you may see our server location differs from your actual location during 2-factor auth procedure.',
        tip2: 'And please remember: Your security and privacy is our No.1 priority. MultCloud does not store your data permanently. It might temporarily cache part of the content based on your operations, however, it will be removed  from our server immediately once the operation is done. And connection between your iCloud Drive and MultCloud servers is always done over a secure 256-bit SSL channel.',
        checkTip: 'Don\'t show this again',
    },
    checkApplePopup: {
        title: 'Two-Factor Authentication',
        tip1: 'You have turned on two-factor authentication. Please enter the verification code on your iPhone/iPad/iPod to continue.',
        tip2: 'Did not get the verification code?',
        btn1: 'Sending message...',
        btn2: 'Resend Code',
        btn3: 'Text Me',
        btn4: 'Get Support',
        suc1: 'A message with a verification code has been sent to {num}.',
        suc2: 'A message with a verification code has been sent to your devices.',
        fail1: 'Failed to send verification code, please try again.',
        fail2: 'Please enter the verification code to continue.',
    },
    downloadThreadPopup: {
        title: "Download Settings",
        tips: "Name on downloaded file",
        defaultNameOne: "Emails saved on {date}",
        defaultName: "{num} emails saved on {date}",
        option1: "Save Attachments",
        option2: "Conversation Format",
        option2Tips: "Quotations will be removed when activated.",
        option3: "Save the last message only",
    },
    failedFilesPopup: {
        title: 'View Failed Files: {num}',
        exportExcel: 'Export as Excel',
        retrySucTip: '{num} Items Added to Retry List.',
    },
    viewLogsPopup: {
        title: 'Task Details：',
        titleRe: 'Restore Details：',
        errorNum: 'Number of Failures',
        addNum: 'Add File(s)',
        updateNum: 'Update File(s)',
        deleteNum: 'Delete File',
        syncSize: 'Sync Size',
        syncTime: 'Sync Time',
        backupNum: 'Backup Number ',
        backupSize: 'Backup Size',
        backupTime: 'Backup Time',
        restoreNum: 'Restore Number',
        restoreSize: 'Restore Size',
        restoreTime: 'Restore Time',
        cloneNum: 'Clone Number',
        cloneSize: 'Clone Size',
        cloneTime: 'Clone Time',
        tranNum: 'Transfer Number',
        tranSize: 'Transfer Size',
        tranTime: 'Transfer Time',
        from: 'From：',
        to: 'To：',
        executeTime: 'Execution Time：',
        sourceAccount:'Source Account',
        targetAccounts:'Target Accounts',
        executeResult: 'Execution Result',
        add: 'Add：',
        update: 'Update：',
        delete: 'Delete：',
    },
    taskProgressPopup: {
        title1: 'You are a premium user, you now have 10 threads to transfer files simultaneously.',
        title2: 'Upgrade to anypremium service to have a maximum of 10 !',
        btnTip: 'Starting From $9.99',
    },
    subfileSelectPopup: {
        title: 'Select Content to Upload',
    },
    deleteBatchPopup: {
        tips1: 'Are you sure you want to delete these <span>{num}</span> tasks? ',
        tips2: 'After the task is deleted, it will not be recoverable.',
    },
    freeSaledPopup: {
        tips1: 'Keep your family\'s memories connected across clouds—claim 10GB FREE this Family Day!',
        tips2: 'Wait ！',
        tips3: 'Looks like you\'re skipping your Father\'s Day gift. Just a reminder:Once skipped, it\'s gone!',
        btns1: 'Claim 10GB',
        btns2: 'No, thanks',
        success: 'Congrats! You’ve just received 10GB of cross-cloud transfer traffic.',
        floatTitle: 'GET 10GB FOR FREE',
        popupTitle: 'GET <span>10GB</span> FOR FREE',
    }
},
addCloud: {
    connectDesc: 'Select a service to connect.',
    box: 'box',
    boxBusiness:'box for Business',
    dropbox: 'Dropbox',
    google_drive: 'Google Drive',
    google_drive_sharedWithMe: 'Shared with me',
    google_drive_v2: 'Google Drive',
    google_drive_shared_v2: 'Shared with me',
    oneDrive: 'OneDrive',
    oneDriveV2: 'OneDrive',
    sugarSync: 'SugarSync',
    amazonS3: 'Amazon S3',
    iDrivee2: 'IDrive® e2',
    wasabi:'Wasabi',
    webDav: 'WebDAV',
    FTP: 'FTP',
    cloudMe: 'CloudMe',
    cubby: 'Cubby',
    myDrive: 'MyDrive',
    yandex: 'Yandex',
    hiDrive: 'HiDrive',
    WEBDE: 'WEB.DE',
    baiDu: 'BaiDu',
    amazon: 'Amazon',
    alfresco: 'Alfresco',
    aDrive: 'ADrive',
    Icedrive: 'Icedrive',
    NAS: 'NAS',
    oneDrive4Business: 'OneDrive for Business',
    dropbox4Business: 'Dropbox Business',
    pCloud: 'pCloud',
    mega: 'MEGA',
    backblaze: 'Backblaze',
    putio: 'Putio',
    googlePhotos: 'Google Photos',
    googlePhotosV2: 'Google Photos',
    gSuiteSharedDrive: 'Shared Drive',
    evernote: 'Evernote',
    flickr: 'Flickr',
    mediafire: 'MediaFire',
    ownCloud: 'ownCloud',
    mySQL: 'MySQL',
    gSuite: 'Google Workspace',
    gSuiteSharedDrive: 'Shared Drive',
    hubiC: 'hubiC',
    egnyte: 'Egnyte',
    youtube: 'youtube',
    facebook: 'facebook',
    picasa: 'picasa',
    goDaddy: 'goDaddy',
    ubuntu: 'ubuntu',
    welcomeTo: 'Welcome to MultCloud',
    welcomeFont: 'Now you can easily transfer and manage all your cloud files with one app. First things first, please connect your cloud to MultCloud.',
    peCloud:'Personal Services',
    buCloud:'Business Services',
    sharePointOnline:'SharePoint Online',
    iCloudPhotos: 'iCloud Photos',
    iCloudDrive: 'iCloud Drive',
    continue: 'Continue',
    gmail: 'Gmail',
    comingSoon: 'Coming soon...',
    signInWith: 'Sign in with',
    outlook: 'Outlook',
    fourShared: '4shared',
},
addEmail: {
    connectDesc: 'Click on the email to connect it to MultCloud',
    peEmail: 'Select and sign in with the Email',
    iCloudNotice: 'iCloud Drive is temporarily unable to connect, and our development team is currently working on resolving the issue.',
    iCloudPhotosNotice: 'iCloud Photos is temporarily unable to connect, and our development team is currently working on resolving the issue.',
},
cloudExploer: {
    uploadFile: 'Upload File',
    newFolder: 'New Folder',
    newAlbum: 'New Album',
    search: 'Search',
    grid: 'Grid',
    pageList: 'List',
    reFresh: 'Refresh',
    modified: 'Modified on',
    openWith: 'Open With',
    officeOnline: 'Microsoft Office Online',
    loading: 'Please wait,loading…',
    uploadFolder: 'Upload Folder',
    trash: 'Trash',
    recentlyDeleted: 'Recently Deleted',
    jumpTo: 'Jump to',
    deleteForever: 'Delete forever',
    restore: 'Restore',
    back: 'Back',
    searchResult: 'Search Result',
    emptyTrash: 'Empty Trash',
    recoverAll: 'Recover All',
    deleteAll: 'Delete All',
    fileExists: 'File Exists',
    chooseOption: 'File exists,please choose an option!',
    needRestore: 'To view this folder, you\'ll need to restore it from your trash',
    limitBoxTip: '1.A few cloud drives may have some limitations. For example, Box doesn\'t support transmission of single file which is larger than 2GB. Such limitations are set by cloud provider and they cannot be broken through by MultCloud. For more info,<a href="https://www.multcloud.com/help/limitations.html" target="_blank" class="add-cloud-link">click here</a>.<br>2. If your tasks still did not get 10 threads after upgrading to premium, please cancel and re-transfer the tasks. Your tasks will get 10 threads to transfer with vip exclusive servers.',
    fileNameNotEmpty: 'The file name you entered can not be empty.',
    notContainSpecialChar: 'The file name can not contain special characters `/ \ | : * ? " < >`.',
    CharacterLimit:'The file name can not contain special characters `~"# %& *: < >？ / \ { | }.`',
    pathNotExist: 'The path doesn’t exist',
    emptyNotice: 'This folder is empty',
    trashEmpty: 'Recycle bin is empty',
    searchEmpty: 'Search results are empty',
    uploadSize: 'The total size of a uploading task can not be greater than 1GB.',
    simultaneous: 'You can add at most 200 tasks simultaneously.',
    cancelFailed: 'Cancellation failed, the task is being created, please try again later',
    notWith: 'The filenames and foldernames cannot begin or end with "."',
    notUpload: 'upload failed.',
    duplicatePhoto: 'Duplicate photo. The photo you are trying to upload is a duplicate and has not been imported into your library.',
    dataLoaded: 'Data loaded',
    sharedDate:'Share Date',
    failedRestore: 'Failed to restore the file, because the target directory contains a file with the same filename.',
    //2020-12-11 lijimin
    uploadError:'This file is forbidden to be downloaded (by the official cloud service).',
    downloadLimit: 'The download limit for today has been reached. Please try again tomorrow.',
    //2022-4-26 wt
    createBucket:'The bucket name should only contain lowercase letters and numbers. The length should be 3-63 characters. p.s. The bucket name should not be all numbers(i.e. "12345678").',
    newBucket:'New Bucket',
    deleteBucket:'MultCloud cannot delete buckets with a naming convention of all numbers(i.e. "12345678").',
    getBucketObjectListFail :'MultCloud cannot list a bucket with a naming convention of all numbers(i.e. "12345678").',
    newAlubm: 'New Album',
    specialCharError: 'The file name can not contain special characters `/ | : * ? " < >`.',
},
emailExploer: {
    from: 'From',
    to: 'To',
    cc: 'cc',
    email: 'Emails',
    subject: 'Subject',
    received: 'Received',
    sentTime: 'Sent',
    downloadMax200: 'At most, you can download 200 emails at a time.',
    noSubject: '(no subject)',
    folderName: {
        Inbox: 'Inbox',
        Starred: 'Starred',
        Snoozed: 'Snoozed',
        Sent: 'Sent',
        Drafts: 'Drafts',
        Important: 'Important',
        Chats: 'Chats',
        Scheduled: 'Scheduled',
        AllMail: 'All Mail',
        Spam: 'Spam',
        Trash: 'Trash',
        Unread: 'Unread',
        Categories_Social: 'Categories_Social',
        Categories_Updates: 'Categories_Updates',
        Categories_Forums: 'Categories_Forums',
        Categories_Promotions: 'Categories_Promotions',
        Categories_Personal: 'Categories_Personal',
    }
},
imageSaver: {
    analyzing: 'Analyzing',
    failedToParse: 'Failed to parse',
    noviceGuidance: 'You can check all recently uploaded images/videos to the cloud or packed images/videos for Instagram here',
    insDownloadExist: 'You have already downloaded this profile. You can find it in the "Task List" section.',
    taskExpiredOn: 'Expired on {time}',
    taskStoringTill: 'Storing till {time}',
    taskPart: 'Part',
    taskUnitFile: 'file',
    taskUnitFiles: 'files',
    taskQueue: 'In a queue',
    taskTabUpload: 'Upload',
    taskTabSaveAll: 'Save All to Cloud',
    taskTabDownload: 'IG Download All',
    downloadInsVideo: 'Download the Video',
    downloadSinglePost: 'Download Entire Post',
    downloadAllPosts: 'Download All Posts',
    downloadAllReels: 'Download All Reels',
    downloadAllStories: 'Download All Stories',
    downloadAllHighlights: 'Download All Highlights',
    saveInsVideo: 'Save the Video to Cloud',
    saveSinglePost: 'Save Entire Post to Cloud',
    saveAllPosts: 'Save All Posts to Cloud',
    saveAllReels: 'Save All Reels to Cloud',
    saveAllStories: 'Save All Stories to Cloud',
    saveAllHighlights: 'Save All Highlights to Cloud',
    insCardPosts: 'posts',
    insCardFollowers: 'followers',
    insCardFollowing: 'following',
    insTabPosts: 'Photos and Videos',
    insTabReels: 'Reels',
    insTabStories: 'Stories',
    insTabHighlights: 'Highlights',
    insBlankText: 'With MultCloud\'s Instagram Downloader, effortlessly download and save Instagram posts, reels, stories, and highlights to manage your favorite content anytime.',
    webGoogleBlankText: 'Effortlessly collect images from any website or Google search and save them directly to your cloud or local storage.',
    noTask: 'No tasks',
    inputTipHttp: 'Enter a website URL or a Google search keyword',
    fetchBtn: 'Fetch Now',
    fetchingBtn: 'Fetching...',
    loadMore: 'Load more',
    downloadAll: 'Download All',
    saveAll: 'Save All to Cloud',
    saveToCloud: 'Save to Cloud',
    clearHistory: 'Clear history',
    cancel: 'Cancel',
    retry: 'Retry',
    view: 'View',
    noImage: 'No content found',
    notSupport: 'Maybe this URL is not supported. Please double-check the URL and try again.',
    inputTipIns: 'Enter an Instagram URL',
    post: 'post',
    posts: 'posts',
    uploadTo: 'Upload to: ',
    download: 'Download',
    uploading: 'Uploading',
    finished: 'Finished',
    all: 'All',
    videoInputTip: 'Paste your video link here',
    videoTip: `Download high-quality videos from YouTube, Facebook, X, and <a href="https://www.multcloud.com/help/video-downloader.html" target="_blank" style="text-decoration: underline;color: #5562B4;">1000+ other sites</a>
    with MultCloud's ad-free, cross-platform Online Video Downloader—no installation required.`,
    process: 'Processing...',
    thumbnail: 'Thumbnail',
    abrTypeVeryHigh: 'Very High',
    abrTypeHigh: 'High',
    abrTypeNormal: 'Normal',
    abrTypeLow: 'Low',
    default: 'Default',
    generat: 'File Generating',
    retryTip: 'The task has been restarted, and you can view the latest progress under the "All" tab.',
},
taskList: {
    taskListDes: 'You can manage cloud transfer, cloud sync and shared file saving tasks here',
    multiCloudSync: 'Multi-Clouds Sync',
    MultiCloudTransfer: 'Multi-Clouds Transfer',
    nextTransfer: 'Next Transfer',
    scheduled: 'Scheduled',
    nextSync: 'Next Sync',
    reTransfer: 'Re-transfer',
    saveNow: 'Save Now',
    transferTasks: 'Transfer Tasks',
    syncTasks: 'Sync Tasks',
    shareTasks: 'Share Tasks',
    backupTasks: 'Backup Tasks',
    emailTransferTasks: 'Email Migration Tasks',
    allTime: 'All Time',
    today: 'Today',
    latestWeek: 'Latest Week',
    latestMonth: 'Latest Month',
    customDate: 'Custom Date',
    allStatus: 'All Status',
    preset: 'Preset',
    noTaskCreated: 'No Task has been created',
    createTransferTask: 'Create a transfer task',
    createSyncTask: 'Create a sync task',
    createRemoteTask: 'Create a remote task',
    timeMustLess: 'Start time must be less than or equal to end time',
    taskNameRule: 'Task name cannot exceed 200 characters',
    backupTaskNameRule: 'Task name cannot exceed 255 characters',
    detailNote: 'This task is still preparing, no detailed progress to be shown.',
    notTraffic: 'Not enough data traffic for cloud to cloud transmission',
    reSync:'Re-sync',
    rebackup:'Re-backup',
    rerestore:'Re-restore',
    //2021-10-11
    createBackupTask:'Create a backup task',
    createTeamTransferTask:'Create a team transfer task',
    multiClouds: 'Multi-clouds',
    speedUP: 'Speed UP',
    noTasks: 'No Tasks',
    noTasksTip: 'Click on the buttons below to create a task',
    startCloudTransfer: 'Start Cloud Transfer',
    startCloudSync: 'Start Cloud Sync',
    loadingTip: 'Hold on a second, please.',
    allTasks: 'All Tasks({num})',
},
cloudTransfer: {
    transferDescription: 'Create a transfer task to transfer files between cloud drives',
    transferOperateFrom: 'Click here to select the cloud drives or folders you\'d like to transfer from',
    from: 'FROM',
    to: 'TO',
    transferOperateTo: 'Click here to select the cloud drive or folder you\'d like to transfer to',
    transferNow: 'Transfer Now',
    transfer: 'Transfer',
    addTaskOnly: 'Add Task Only',
    addTaskNow: 'Add Task and Transfer Now',
    addSyncTaskNow: 'Add Task and Sync Now',
    addBackupTaskNow:'Add Task and Backup Now',
    transferSucces: 'Transfer Successful',
    sureContinue: 'You have seleceted more than 10 source items and each source item corresponds to a notification Email. That means you may receive more than 10 notification Emails. Are you sure to continue?',
    sure: 'Yes, I\'m Sure.',
    //2020-10-29ljm新增
    sourceRemind:'The maxium number of source items is 200. Please select less items or select a whole folder. P.S. A whole folder only counts one item.',
    backupSourceRemind:'The maxium number of source items is 1000. Please select less items or select a whole folder. P.S. A whole folder only counts one item.'
},
cloudSync: {
    syncDescription: 'Create a sync task to sync files between cloud drives',
    syncOperateTo: 'Click here to select the cloud drives or folders you\'d like to sync to',
    syncOperateFrom: 'Click here to select the cloud drive or folder you\'d like to sync from',
    syncNow: 'Sync Now',
    taskEmpty: 'Task name cannot be empty.',
    //2020-10-29ljm新增
    aimRemind:'The maxium number of target directories is 200.',
    realTimeSync:'Real Time Sync',
    normalSync:'Normal Sync',
    pause:'Pause',
    paused:'Paused',
    swicthTwoWay:'Switch to two-way sync',
    switchOneWay:'Switch to one-way sync',
    fristSync:'First Sync',
    lastSync:'Last Sync',
    initSync:'Initial sync of data is still in progress, please wait.',
    realSyncing:'Real-time Syncing...',
    servicesSu:'Cloud services supported for real time sync',
    addRealDrives:'You must add a cloud drive that supports real time sync.',
    egDrives:'For now, only Google Drive, Dropbox, Dropbox Business, OneDrive, OneDrive for Business, G Suite, box are supported for real time sync.',
    initTial:'Initializing',
    realSync:'Real-time Sync',
    createdAt:'Created at',
    oneWaySimple:'One-way(Simple Sync)',
    twoWay:'Two-way(Coming Soon...)',
    gooleFolder:'It will not sync if there\'re only changes in subdirectories of a Google Drive folder.',
    realTimeNotice:'You can have up to 2 real time sync tasks running at the same time, so some of your sub-tasks will be paused. Are you sure to continue? ',
    reachMax:'You have reached the maximum number of logs, only the latest logs are shown.',
    notRun:'The task is not running.',
    bePaused:'if the real time sync task remains non-operating state for over 7 days, it will be automatically paused.',
    dontShow:'Don\'t show this again',
    timeOut:'Traverse timed out',
    outMostly:'Traverse timed out is mostly because there are too many files or too many sub-directories for real time sync. We suggest to create a normal sync task instead.'
},
emailTransfer: {
    cloudEmail: 'Email Migration',
    description: 'Migrate your email to cloud as PDF.',
    migrationSetting: 'Migration Settings',
    cutSetting: 'Cut Settings',
    copySetting: 'Copy Settings',
    settingTips: 'Setting for the transfer',
    notification: 'Notification',
    watermark: 'Watermark',
    delWatermark: 'Remove the watermarks from emails downloaded as PDFs',
    saveAtt: 'Save Attachments',
    converFormat: 'Conversation Format',
    converFormatTip: 'Quotations will be removed when activated.',
    saveOnly: 'Save the last message only',
    optionTitle: 'Some emails already exists, what would you want to do?',
    filterTitle: 'You can specify additional filter for FROM selection.',
    filterMessage: 'Please enter emails and separate them with comma',
    filterOption1: 'Overwrite it if the conversation has been updated',
    filterOption2: 'Always skip',
    filterOption3: 'Always rename',
    filterOption4: 'Has attachment',
    filterOption5: 'Is unread',
    transferNow: 'Migrate Now',
    filterDateOptions1: 'Any time',
    filterDateOptions2: 'Older than a week',
    filterDateOptions3: 'Older than a month',
    filterDateOptions4: 'Older than 6 months',
    filterDateOptions5: 'Older than a year',
    filterDateOptions6: 'Custom range...',
    showMore: 'show more',
    startDate: 'Start date',
    endDate: 'End date',
},
exception: {
    exceedMaxLimit: 'The number of request exceeded the maximum.',
    cloudNameExist: 'This display name already exists, please enter another.',
    pathNotFound: 'Check if file or folder by given path exists.',
    notBeTheSame: 'The source folder and target folder could not be the same.',
    notTransferring: 'This directory can not be selected for transferring files, please select its subdirectories or other directories.',
    verifyCodeInvalid: 'Verification code error.',
    nameEmpty: 'The display name can not  be empty',
    emailEmpty: 'Email can not be empty',
    serverEmpty: 'Server can not be empty',
    usernameEmpty: 'Username can not be empty',
    passwordEmpty: 'Password can not be empty',
    domainEmpty: 'Domain can not be empty',
    bucketNameEmpty: 'Bucket Name can not be empty',
    accessKeyEmpty: 'Access Key ID can not be empty',
    secretAccessKeyEmpty: 'Secret Access Key can not be empty',
    keyIdEmpty: 'keyID can not be empty',
    applicationKeyEmpty: 'applicationKey can not be empty',
    onlyAlbum: 'Only album directories created or shared by MultCloud can be selected for storing images, videos and other media files.',
    parametersNotEmpty: 'The parameters should not be empty.',
    notMediaFiles: 'Note: The "Albums" directory can only store album directories, but not media files.',
    notStoreDirectories: 'The "Photos" directory can not store directories.',
    onlyStoreImages: 'Note: The "Photos" directory can only store images, videos and other media files, but not directories',
    //400 云盘管理
    unknownError: 'Connection to this service failed. Please reauthorize MultCloud\'s access to the service.',
    addCloudFailed: 'Some parameters are not entered correctly.',
    renameCloudFailed: 'Failed to rename the cloud,please try again later.',
    deleteCloudFailed: 'Failed to delete the cloud,please try again later.',
    invalidCloudAccount: 'This cloud account doesn\'t exist.',
    //邮件管路
    bindEmailFail: 'Failed to bind email.',
    linkHasExpired: 'The link is expired.',
    //文件管理
    listItemsFailed: 'Failed to list files, please re-add cloud to MultCloud.',
    deleteItemFailed: 'Failed to delete item.',
    renameItemFailed: 'Failed to rename item.',
    createFolderFailed: 'Failed to create folder.',
    moveItemFailed: 'Failed to move item.',
    shareItemFailed: 'Failed to share item.',
    uploadFailed: 'File data not found.',
    toFolderIdBlanked: 'The "tid" is blanked',
    downloadFileFailed: 'Failed to download the file,please refresh the page or re-add cloud to MultCloud.',
    //任务管理
    addTaskFail: 'Failed to add task.',
    taskQuotaLimit: 'You have reached the maxium number of 200 cloud-to-cloud transfer tasks, please delete some unimportant tasks.',
    deleteTaskFail: 'Failed to delete task.',
    maxRunningLimit: 'The running task exceeds the maximum number and this task can be added as waiting',
    userCreateFail: 'Failed to create user, please try again later.',
    userUpdateFail: 'Failed to modify account information, please refresh the page and try again.',
    createSaltFail: 'Failed to create salt, please try again.',
    listFolderFailed: 'Failed to list the folder, please try to re-add the cloud.',
    //401
    cloudCategoryInvalid: 'The cloud service is longer supported anymore.',
    executeTaskFail: 'Failed to execute task,please check your web connection.',
    parameterInvalid: 'The parameters are invalid',
    saltInvalid: 'Your session has expired, please log in again.',
    emailInvalid: 'It is not a valid email.',
    notAuthorized: 'The username or password is not correct.',
    //403
    cloudNameEmpty: 'The display name can\'t be empty.',
    addCloudExpired: 'Failed to add cloud, please re-add the cloud service.',
    verifyCodeInvalid: 'The verification code is invalid.',
    emailExist: 'The email already exists.',
    exceedMaxLimit: 'The requests exceed the maximum number.',
    userIdNotNull: 'The userid is null',
    //404
    notFoundTask: 'The task is not found.',
    noTaskRunning: 'No task is running',
    userNotFound: 'The user is not found.',
    loginerNotFound: 'The loginer is not supported',
    deletePermissionLimited:'You can’t proceed with this operation, because you don’t have “Delete Permission”',
    notHaveDeletePermission: 'You do not have permission to delete the file/folder.',
    uploadPermissionLimited:'You can’t proceed with this operation, because you don’t have “Upload Permission”',
    movePermissionLimited:'You cannot proceed with this operation because you do not have "permission to move"',
    copyPermissionLimited:'You cannot proceed with this operation because you do not have "permission to copy"',
    notHavePermission:'Due to the lack of write permission, you are unable to paste this file/folder.',
    cutPermissionLimited:'You do not have permission to cut and paste this file/folder.',
    mkdirPermissionLimited:'You can’t proceed with this operation, because you don’t have “Create Folder Permission”',
    notCreatPermission: 'You cannot create a bucket or folder due to lack of write permission or insufficient space.',
    creatIDriveFolderError: 'Object name contains unsupported characters.',
    creatIDriveFolderToLong: 'Folder name cannot exceed 245 characters.',
    noUploadPermission: 'Due to lack of upload permissions or insufficient cloud storage space, you are unable to upload this file.',
    bucketNameLongError:'Bucket names must be 3 to 63 characters long, use only lowercase letters, numbers, dots (.), and hyphens (-), start and end with a letter or number, and avoid consecutive periods.',
    bucketNameIsNotIp: 'Bucket name cannot be an IP address.',
    renamePermissionLimited:'You can’t proceed with this operation, because you don’t have “Rename Permission”',
    downloadPermissionLimited:'You can’t proceed with this operation, because you don’t have “Download Permission”',
    ipNotFound: 'The ip is not found',
    sugarSyncWarn: 'It is not supported to select the directory, please select the "Web Archive","Magic Briefcase","Mobile Photos" directory, its subfolders or other directories.',
    flickWarn: 'It is not supported to select the directory, please select the "/Albums" directory, its subfolders or other directories.',
    baiDuWarn: 'It is not supported to select the directory, please select the "全部文件/我的应用数据/Multcloud" directory, its subfolders or other directories.',
    dropBoxbusinessWarn: 'It is not supported to select root directory, please select the other directories.',
    createFolderFail: 'Failed to create the folder',
    //mega报错
    addMegaFailed: 'Some parameters are not entered correctly or you have activated F2A.',
    //mySql报错
    mySqlWarn:'This cloud cannot be selected as the target of cloud-to-cloud transfer.',
    //2020-10-29ljm新增
    maxTaskRemind:'You have reached the maximum number of 5000 cloud transfer/sync tasks. Please delete some unnecessary tasks and try again. P.S. If there\'re 3 sources in a transfer task, the transfer task will count as 3 tasks.',
    // 2020-11-25 yjs
    torrentTort:'This content is unauthorized or infringing copied.',
    //2020-12-4 xth
    shareNotUpload:'The owner has canceled \"allow to upload\" permission, please refresh the page.',
    //2020-12-9 xth
    shareItemUpdate:'The owner has changed the permission of this sharing link, please refresh the page.',
    nameLong:'User name is too long (20 Characters Max.)Your user name is long than 20 characters.',
    notPermission:'This is a team file and you don\'t have permission to execute this operation.',
    notOpened:'This cloud doesn\'t support real time sync.',
    taskNotFound:'The task doesn\'t exist.',
    subscribeFail:'Failed to create task.',
    driveAccountIdInvalid:'Can\'t create the real-time sync task. Please remove and re-add the selected cloud services and try again.',
    unknownState:'Can\'t execute this operation, please try again later.',
    InvalidParameter:'Invalid Parameter.',
    InvalidDirectory:'The root dirctory of box doesn\'t support this feature.',
    HasExist:'The instant synchronization task for this folder already exists, please cancel the instant synchronization task for this folder and recreate it in the folder',
    // taskRunningNumberLimited:'You can run 5 cloud-to-cloud tasks in parallel, please cancel a running task and try again.',
    taskRunningNumberLimited:'There are already 2 real-time sync tasks in running status and please pause a real-time sync task first',
    reachedLimit:'You have reached the rate limit of this cloud, please try again later.',
    selectAlbumWarn:'Note: An album directory can only store images, videos and other media files, but not directories',
    notSupported:'Real time sync is not supported for multi-target tasks for now.',
    incorrectFormat:'Sorry, your phone number format is incorrect.',
    taskMaximumNumberLimited:'You have reached the maximum number of 200 real-time sync tasks. Please delete some unnecessary real-time sync tasks and try again.',
    autoLoginFail: 'You\'ve activated two-step verification, please log in again.',
    unsubscribeFail:'unsubscribe fail',
    //云盘操作报错
    alreadyAdd:'You’ve already added the cloud drive.',
    toggleWhileEditing:'The account you added does not match the current account.',
    //2022-4-25 wt
    emptyBucket:'You can\'t delete buckets which are not empty. P.S. Please make sure  there are also no objects in bucket versioning of Wasabi.',
    cannotCopyFolder:'You can\'t copy a folder to the same bucket.',
    cannotCopyIdrivee2Folder: 'Folders under the same Idrive e2 account cannot be copied to each other.',
    cannotCutFolder: 'Folders under the same bucket cannot be cut and pasted to each other.',
    bucketAlreadyExists:'The requested bucket name is not available. The bucket namespace is shared by all users of the system. Please select a different name and try again.',
    accessPermissionLimited:'You don\'t have the permission to access this folder.',
    accessDenied:'Access denied, you are not authorized to perform this operation.',
    shareTransferCanotCopy: 'Copying the root folder of a multi-items share is not supported for now.',
    // 2022-6-8 wt
    sharePointOnlineNotTrans:'SharePoint root directory can not be selected for transferring files, please select a subdirectory of a site.',
    sharePointListFailed:'Error 500: InternalServerError. Tips: Please check if this account has access to SharePoint service.',
    sameDirError: 'The source account and the target account cannot be the same.',

    accessDenied:'Access denied',
    //iCloudPhotos报错
    onlySaveAlbums: 'Note: The target directory you select can only save albums (folders).',
    notSelectICloudPhotosRoot: 'Note: The root directory of iCloud Photos can only save albums (folders).',
    notSelectICloudPhotosForder: 'Note: The directory you select can only save album directories (folders).',
    notSelectICloudPhotosAlbum: 'Note: The target directory you select can only save images (folders not available).',
    notSelectICloudPhotosOther: 'Note: The target directory you select cannot save images directly, all images transferred will be saved to "Recents" folder.',
    notSelectICloudPhotosBackup: 'iCloud Photos cannot be selected as the target for “Cloud Backup”. To save images in iCloud Photos, please select “Cloud Transfer” or “Cloud Sync”.',
    notSelectICloudPhotosSyncRoot: 'Note: Can’t sync images to the root directory of iCloud Photos.',
    notSelectICloudPhotosSync: 'This is a folder in iCloud Photos, you can only sync images to albums in iCloud Photos.',
    sendTooMany: 'Too many verification codes have been sent. Enter the last code you received, use one of your devices, or try again later.',
    verifySecurityCodeFailed: 'Failed to verify, please check and re-enter the verification code',
    appleNotEnablePhotos: 'iCloud Photos is currently unavailable for you Apple ID. To use iCloud Photos, please sign in with the Apple ID with an Apple device and try again.',
    tooManyRequests429: 'User-rate limit exceeded. Retry after {date}.',
    tooManyRequests403: 'Too many requests at the same time, please try again later.',
    // iCloudDrive报错
    folderNameIsTooLong: 'The folder name can\'t exceed 255 characters.',
    fileNameIsTooLong: 'The file name can\'t exceed 250 characters.',
    iCloudDriveNotEnoughSpace: 'Not enough space to upload the file.',
    uploadFileIsTooBig: 'The file is too large to upload. MultCloud currently limits uploads to a maximum of 100 MB.',
    uploudFileSizeIsZero: 'It is not possible to upload zero byte files to iCloud Drive.',
    notUploudSpecialFile: 'Cannot upload this type of file to this App Library.',
    notRenameApp: 'Apple doesn\'t allow to rename the App folders, such as Pages, Numbers, and Keynote.',
    ErrorDeleteDistinguishedFolder: 'Distinguished folders cannot be deleted.',
    moreThan256Characters: 'The folder name cannot exceed 256 characters.',
    cloudNotFound: 'The Cloud has been removed.',
    fourSharedUnauthorized:'Your 4shared authorization has expired. Please reauthorize your account by "Re-add".',
    fileFolderNameLengthExceed:"File/Folder name length could not exceed 255 characters.",
    invalidLink: 'Invalid link',
    requestFailed: 'Request failed.',
    exceeds2GB: 'File size exceeds 2GB and cannot be downloaded.',
    licenseUpgradError: 'The license is not available as you are a {scheme} subscriber',
    noLicenseCode: 'Please enter a license code',
    licenseCodeError: 'The license code you\'ve entered is incorrect',
},
preview: {
    fileNotReview: 'files cannot be reviewed',
    goOringinalSite: 'Go to Original Site'
},
remoteTask: {
    remoteTask: 'Remote-task',
    createTask: 'Create Task',
    successsExceed: 'Link Copied!',
    operateSuccess: 'Operate Success',
    noRemote: 'No remote task has been created',
    unKnownError: 'An unknown error',
    undefinedDisk:"Can't find the target directory, please copy the download link and create new remote upload task.",
    taskExpired:'It has expired. Please try again',
    createDescribe:'Transfer files from Links, Torrents, Magnets directly to your clouds.',
    saveURLDescribe:'Save files from URL links directly to your clouds.',
    noSelectFile: 'Please select a file',
    excuteNow:'Execute Now',
    maxLimit:'The number of remote tasks cannot be over 1000, please delete some unimportant tasks.',
    noSeeds:'Low Resource',
    failedToParse:'Failed to Parse',
    parseMagnetRunning:'Parse seeds, please wait...',
    selectedFileLimit:'The number of files selected cannot exceed 500 and the total size cannot exceed 50GB.',
    addLink: 'Add Link',
    startEmailSend: 'Send Email Notification Upon Task Completion',
    nowUpload: 'Upload Now',
},
shares: {
    myShares: 'My shares',
    savedShares: 'Saved Shares',
    sharedOn: 'Shared on',
    allowedTo: 'Allow to Upload',
    location: 'Location',
    shareNull: 'You haven’t shared any file yet.',
    shareNullTips: 'Tips: To share a file, you can just right click on the file and select “Share” option.',
    savedShareNull: 'You haven’t saved any shared file yet.',
    savedShareNullTips: 'Tips: If someone shares a sharing link to you, you can save it here for quick access.',
},
login: {
    experienceSigning: 'Experience without signing',
    forgotPassword: 'Forget Password?',
    signIn: 'Sign in',
    rememberMe: 'Remember me',
    keepLogin: 'Keep me logged in',
    loginWith: 'Login with',
    email: 'Email',
    password: 'Password',
    verificationCode: 'Verification Code',
    firstName: 'First Name',
    lastName: 'Last Name',
    confirmPassword: 'Confirm Password',
    createAccount: 'Create Account',
    continueWith: ' or continue with',
    resetMessage: 'Send Reset Message',
    enterEmail: 'Enter the email address you signed up with below. An email will be sent containing a link to reset your password.',
    enterCorrectEmai: 'Please enter the correct format of email address.',
    passwordCharacters: 'Password must be 8-16 characters',
    passwordDiff: 'The two entered passwords are inconsistent',
    enterCode: 'Please enter the verification code.',
    sentSuccess: 'The email has been sent successfully.',
    successfully: 'Sign up successfully',
    pleaseEmail: 'Please enter your email',
    pleasePassword: 'Please enter your password',
    accountActivated: 'Your account has not been activated.',
    enterCorrectPass: 'Please enter the correct email address or temp account name and password.',
    resetPasseord: 'To protect your account, please click on “Forgot Password” to reset your password.',
    validEmail: 'Please enter a valid email',
    enterFirstName: 'Please enter your first name.',
    enterLastName: 'Please enter your last name.',
    reEnterPass: 'Please re-enter your password.',
    creatingAccount: 'By creating an account, you agree to the',
    termsUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
    thankYou: 'Thank You!',
    checkEmail: 'Please check your email',
    confirmRegistration: 'to confirm your registration. You can skip the activation process and use our product normally, but if you forget your password we cannot help you recover it.',
    noteReceiveEmail: 'Did not receive email?',
    receiveConfirmationEmail: 'If you did not receive a confirmation email, please email us at',
    buttonResend: 'or click the button to resend.',
    forgetEmail: 'Forgot your email address?',
    sendEmailSupport: ' Send an email to support',
    trackDown: 'and we\'ll track it down.',
    passwordnotMatch: 'The password you entered don’t match',
    enterVaildPassWord: 'Please enter a valid password',
    usernameNotContain: 'The username can not contain special characters.',
    updatedSuccessfully: 'Your data has been updated successfully',
    thankBindEmail: 'Thank you for binding email address, please check the activation email in time',
    failExceedOperation: 'Fail to exceed this operation',
    enterNewPassword: 'Please enter the new password',
    confirmationPassword: 'Please enter the confirmation password',
    userNameNot: 'user name can not be empty',
    //login popup用
    signUp: 'Sign up',
    logInButton: 'Log in',
    logInWith: 'Log in with',
    logToMultCloud: 'Log in to MultCloud',
    logEmailInput: 'Email/Temp account name',
    verificationIncorrect: 'The verification you entered is incorrect.',
    signUpTitle: 'Sign up and get free 5GB data traffic every month',
    title: "Transfer it to your cloud services with MultCloud.",
    tips: "Already have an account?",
    tips2: "Don't have an account?",
    btnTxt: "loging in ...",
    facebook: "Facebook",
    google: "Google",
    exception: {
        strEmpty: "Please fill out this field.",
        nameToLong: "Your username must be 1-20 characters.",
        emailError: "Please enter a valid email address.",
        pwdError: "Please enter password with 8-16 characters.",
        rePsdEmpty: "Please re-enter your password.",
        rePwdError: "Password don't match.",
        codeEmpty: "Please enter the verification code.",
        codeError: "The verification code must be 4 characters.",
        verifyCodeInvalid: "Verification code is not correct.",
        emailExist: "The email address has already been registered.",
        emailPsdError: "Email/Temp account name or password is not correct.",
    }
},
home: {
    driveNameNotContain: 'The Drive name can not contain special characters `/ \ | : * ? " < >  &`.',
    cloudDiskName: 'Cloud disk name cannot exceed 200 characters.'
},
sharesPage: {
    linkFailure: 'Sorry, this shared file has been canceled.',
    linkMasking: 'Sorry, this shared file has been blocked from viewing.',
    saveCloud: 'Save to Cloud',
    directDownload: 'Direct Download',
    saveLink: 'Save the Link',
    cancelShare:'Cancel Share',
    uploadFile: 'Upload File',
    newFolder: 'New Folder',
    saveLinkSuccessBefore: 'You have successfully saved the link.',
    saveLinkSuccessAfter: ' View Saved Links',
    saveLinkFail: 'Failed to save the link.',
    downloadingFolder: 'Downloading folder is not supported at present.',
    downloadingMore: 'You can only download one file at a time.',
    downloadingNone: 'Please select a file.',
    sharecanceledSuccess: 'Share canceled.',
    sharecanceledFailed: 'Failed to cancel share.',
    newFolderInRoot: 'Please enter subdirectories to create a new folder.',
    uploadFileInRoot: 'Please enter subdirectories to upload a file.',
    selectFileTransfer: 'Please select a file to transfer.',
    createTransferFailed: 'Failed to create transfer task.',
    createTransferSuccessBefore: 'You have successfully created a transfer task.',
    createTransferSuccessAfter: ' View Task',
    addCloudService: 'Add Cloud Service',
    mustAddClouds: 'You must add valid cloud drive',
    selectSaveCloudTitle: 'Please Select',
    moreClouds:'More Clouds',
    saveLinkExists: 'The link already exists.',
    errorShare404: 'Source file not found.',
    passWordError: 'Incorrect Password!',
    passWordNone: 'Password should not be empty.',
    passWordInputTitle: 'MultCloud private share file',
    passWordInputMsg: 'Please enter the password.',
    passWordInputButton: 'OK',
    loginErrorMax: 'You haven\'t updated your password for quite long, please update your password.',
    uploadFolder: 'You can only upload files at present.',
    pleaseSignIn: 'Please sign in MultCloud.',
},
share:{
    noManageMyShare: "You can manage all your shared files here.",
    noManageSavedShare: "You can manage all saved shares here.",
    unknownError: "The sharing file is missing, it might be moved or deleted.",
    privateShareText: "(Please contact me to get the password)",
},
inviteFriends:{
    titleBefor: 'Invite as many friends you can and get ',
    titleAfter: ' traffic for each friend you invited! No quota limit!',
    shareEmailTitle: 'Share invitation: ',
    shareLinkTitle: 'Share invitation link: ',
    emailSend: 'Send',
    emailTip: 'Add Email address here',
    wonMonthFlows: 'Lifetime additional traffic you have won in this month: ',
    wonMonthTitle: 'Get a chance to win LIFETIME UNLIMITED data traffic!',
    lastWinner: 'Last Winner ',
    winnerInvites: 'With {num} invites',
    winnerTip: 'Won LIFETIME UNLMITED',
    statusTitle: 'Your Sharing Status',
    successInvites: 'Successful invites this month: ',
    chanceWin: 'Chance to win: ',
    tipsTitle: 'Terms',
    tipsOne: 'Only invited users with a verified Email count as a successful invite.',
    tipsTwo: 'No quota limit for the traffic you earn by inviting people.',
    tipsThird: 'If you\'re already an unlimited traffic subscriber, you cannot win 2GB from a successful invite, but your chance to win Life-time Unlimited service will be doubled.',
    shareText: 'MultCloud - Transfer and manage your multiple cloud files with one app. Join MultCloud today and get 2 GB cloud-to-cloud traffic bonus!',
},
paySystem:{
    billed:'Billed at $0.099/GB for Additional Traffic',
    subCould:'Subscribers could use 50GB/$5.9 and 100GB/$9.9 for additional data traffic if data traffic is not enough',
    limitedMonth:'150GB/Month',
    limitedTrafficMonth:'150GB Traffic/Month',
    unlimitedTraffic:'Unlimited Traffic for LifeTime!',
    foraYear:'Unlimited Traffic for a Year',
    noNeedPurchase:'No need to purchase additional traffic',
    yearlyPayment:'Yearly Payment($7.5/Month)',
    validityData:'The validity of data traffic you buy is permanent',
    additionalPackage:'Additional Traffic Package',
    subscriptmc:'Your Subscription of MultCloud',
    upgradeMore:'Upgrade to MultCloud Premium for more transfer traffic and extra benefits',
    recommended:'Recommended',
    toUnlimited:'Upgrade to Unlimited',
    otherPlan:'Other Plans',
    moreTraffic:'Buy More Traffic',
    monthlySubscriber:`You’re a monthly subscriber and you have 150GB data traffic to transfer or sync data between cloud storage
    <br>
    services every month.`,
    moreDetails:`<a class='add-cloud-link sysLink'>More details about the privileges >></a>`,
    dataTraffic:'Data traffic usage of current month',
    cloudTraffic:'Cloud to Cloud Traffic',
    buyNow:'Buy Now',
    specialOffer:'Special Offer',
    lifetimeFree:'Lifetime Free',
    unsubscribe:'Unsubscribe',
    includes:'Includes',
    reSubscription:'Reactivate Subscription',
    monthTraffic:'Unlimited Traffic for a Month',
    threeMonth:'30GB/Month',
    monthlyPayment:'Monthly Payment',
    monthlyUnlimited:'Monthly Unlimited',
    gb:'GB',
    YearlyUnlimited:'Yearly Unlimited',
    YearlyPaymentNine:'Yearly Payment($9.9/Month)',
    Onetime:'One-time Payment',
    twoMonthree:'200GB/Month x3',
    QuarterlyPayment:'Quarterly Payment($8.3/Month)',
    fourMOne:'400GB/Month x12',
    quarterlySubscriber:`You’re a quarterly subscriber and you have 200GB data traffic to transfer or sync data between cloud storage
    <br>
    services every month.`,
    yearlySubscriber:`You’re a yearly subscriber and you have 400GB data traffic to transfer or sync data between cloud storage
    <br>
    services every month.`,
    expireIn:'Expire in',
    billYearly:'Billed Yearly',
    billMonthly:'Billed Monthly',
    billQuarterly:'Billed Quarterly',
    twoMonTrafficthree:'200GB Traffic/Month x3',
    fourMTrafficOne:'400GB Traffic/Month x12',
    deleteSubAccount:'You have to unsubscribe to delete your account, are you sure to do this?',
    payFirst:'You must',
    paybindEmail:`<a class='add-cloud-link sysLink'> bind your email address and verify it </a>`,
    payEnd:'first before subscribing, because we need to ensure that you can successfully receive the important emails about your subscription.',
    yearlyPaymentTxt:'Yearly Payment',
    quarterlyPaymentTxt:'Quarterly Payment',
    //2021-5-20新加
    upUnlimited:'Upgrade to Yearly Unlimited',
    payDiff:'Only pay the price difference!',
    yearlyUnlimit:'MultCloud (<b>Yearly Unlimited</b>)',
    providesUnlimited:'Yearly Unlimited plan provides unlimited data traffic to transfer or sync data between cloud storage services for 12 months.',
    subProduct:'This is a subscription product with a fee of',
    perYear:'per year.',
    cancelSubscription:'You may cancel your subscription at any time.',
    defaultPayment:'The default payment method is',
    anotherPayment:'If you\'d like to use another payment method, please ',
    clickHere:'click here',
    tryAgain:'The payment can\'t be done for now. Please check your payment method and try again.',
    contactPayment:'Have a problem with the payment? Please be free to contact <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
    Notice:'Notice',
    beforeBind:'Please bind your email address before subscribing.',
    processorder:'Processing order',
    eachGbMoney:'$0.118/',
    eachGbMoneyT:'$0.099/',
    payCouponQuartly:'Quarterly Payment($6.63/Month)',
    payCouponlimitedYearly:'Yearly Payment($5.83/Month)',
    payCouponunlimitedYearly:'Yearly Payment($7.49/Month)',
    payCouponunlimitedYearlyLow:'Yearly Payment($6.66/Month)',
    tips:'Tips: If you have any questions, please be free to contact:<div class="pay-scheme-email"></div><a href="mailto:support@multcloud.com">support@multcloud.com.</a>',
    monthly:'Monthly 150GB',
    //新版付费页面
    payTitle: 'Choose the right MultCloud for you!',
    limitedData: 'Limited Data',
    unlimitedData: 'Unlimited Data',
    monthly: 'Monthly',
    annually: 'Annually',
    save58: 'Save up to 58%',
    payTip: 'Contact Our Sales Team',
    limitTips: 'Unused data traffic will accumulate',
    unlimitTips: 'No data limit concerns anymore',
    tips2: 'If you encounter any problem during the online purchase, please feel free to contact us at: <a href="mailto:support@multcloud.com">support@multcloud.com.</a>',
    vipUpgradeTips: 'Tips: This is the offer for {type} plan users.',
    tabPayScheme: {
        perMonth: 'Monthly Payment',
        perYear: 'Annual Payment',
        perNextYear: 'for the first year (renews at {price})',
        refundDays: 'Days Money Back Guarantee',
        advanced: 'Advanced Features',
        payPremium: 'Upgrade to any premium plan and enjoy all advanced features below',
        payUnlimited: 'Upgrade to any UNLIMITED plan and enjoy all advanced features below',
        freeTip1: 'More Cloud-to-cloud Data Traffic',
        freeTip2: 'UNLIMITED Cloud-to-cloud Data Traffic',
        freeTip3: 'Scheduled Transfer/Sync/Backup',
        freeTip4: 'Double Sync',
        freeTip5: '10 Transfer Threads',
        freeTip6: '8 Sync Modes',
        freeTip7: 'File Filter',
        freeTip8: 'VIP Transfer Server',
        freeTip9: 'VIP Customer Support',
        freeTip10: '5 Cloud-to-cloud tasks in parallel',
        freeTip11: 'Unlimited Emails Conversions',
        freeTipTitle1: 'Subscribers can have 2 real-time sync and 2 normal sync tasks (4 in total).',
        freeTipTitle2: 'There are 10 transfer threads for subscribers while 2 transfer threads for free users.',
        freeTipTitle3: 'Two-way sync and 7 custom options in one-way sync, mirror sync supported.',
        freeTipTitle4: 'Setup a Filter to transfer or sync files with user-defined filename or certain extensions automatically.',
        freeTipTitle5: 'Subscribers can run 5 cloud-to-cloud tasks in parallel while free users can run 1 task at a time.',
        freeTipTitle6: 'Subscribers can convert an unlimited number of emails into PDFs, whereas free users are limited to converting 50 emails per month.',
    },
    nowPayScheme: {
        clearInsCountText: 'But the unused download quota for Instagram profiles will be cleared.',
        manageYourPlan: 'Manage your plan',
        price: 'Price',
        paymentMethon: 'Payment Method',
        autoRenewal: 'Auto-renewal',
        priceVat: 'Includes {currency}{vatPrice} VAT ({percent}% on {currency}{netPrice}).',
        defaultPayment: '{method}, xxxxxxxxxxxx{num}.',
        paypalPayment: 'The default payment method is PayPal.',
        changePayment: 'Change payment method',
        activated: 'Next billing date {time}',
        deactivated: 'Next billing date {time}',
        appleTip: 'Your current {name} was purchased in Apple Store.',
        appleTipId: 'Apple Transaction ID: {id}.',
        googleTip: 'Your current {name} was purchased in Google Play.',
        googleTipId: 'Google Play Order ID: {id}.',
        appNextTimeTip: 'Auto-renewal is activated. Next billing date will be {time}',
        appNoSubscribe: 'Auto-renewal is deactivated.',
    },
    // 免费用户弹窗
    freePlanPopup: {
        title_traffic: 'Oops！Insufficient Cloud-to-cloud Traffic',
        title_ins: 'You have reached the limit of downloads',
        title_pdf: 'You\'ve reached the Email-to-PDF conversion limit',
        title_modes: 'The Sync Mode You\'ve Selected is Exclusive to Premium Plans',
        title_remote: 'You’ve reached the Remote Upload limit',
        title_subtasks: 'You have reached the limit for Team Transfer',
        title_scheduled: 'Scheduled Transfer/Sync/Backup is Premium-Only',
        title_speed: 'Quintuple Transfer Speed is Exclusive to Premium Plans',
        title_sync: 'You have reached the limit for Normal Sync',
        title_real: 'You have reached the limit for Real Time Sync',
        title_filter: 'File Filter is Exclusive to Premium Plans',
        desc: 'Upgrade to Unlock ALL Advanced Features',
        itemTitle_th: 'Features and Benefits',
        itemTitle_traffic: 'Cloud-to-cloud Traffic',
        itemTitle_ins: 'Ins Profiles to Download',
        itemTitle_pdf: 'Convert Email to PDF',
        itemTitle_modes: 'Sync Modes',
        itemTitle_remote: 'Remote Upload Tasks in Parallel',
        itemTitle_subtasks: 'Migrate sub-accounts between team',
        itemTitle_scheduled: 'Scheduled Transfer/Sync/Backup',
        itemTitle_speed: 'Transfer Speed',
        itemTitle_sync: 'Normal Sync Tasks in Parallel',
        itemTitle_real: 'Real Time Sync Tasks in Parallel',
        itemTitle_filter: 'File Filter',
        itemTitle_tran: 'VIP Transfer Server',
        itemTitle_customer: 'VIP Customer Support',
        itemTitle_watermark: 'Remove watermark from PDF email',
        itemValue_cur: 'Your current',
        itemValue_free: 'Free',
        itemValue_upgrade: 'Upgrade to',
        itemvalue_premium: 'Premium',
        itemvalue_5gb: '5 GB / Month',
        itemvalue_1profile: '1 Profile / Month',
        itemvalue_50emails: '50 Emails / Month',
        itemvalue_maxUnlimited: 'Maximum Unlimited',
        itemvalue_unlimited: 'Unlimited',
        button: 'Upgrade from $9.99',
    },
    // 套餐的支持项
    supportItem: {
        yourCurPlan: 'Your current plan',
        // 第1组
        gb5: '5GB free data traffic per month',
        gb100: '100GB data traffic per month',
        gb200: '200GB data traffic per month',
        gb1200: '1200GB data traffic per year',
        gb2400: '2400GB data traffic per year',
        gbUnlimitedYear: 'Unlimited data traffic per year',
        gbUnlimitedLifetime: 'Unlimited data traffic for a lifetime',
        gbPackage50: '',
        gbPackage100: '',
        gbGiveAway500: '',
        gbGiveAway200: '',
        ins1: '1 Ins Profile to Download per month',
        ins10: '10 Ins Profiles to Download per month',
        ins20: '20 Ins Profiles to Download per month',
        ins120: '120 Ins Profiles to Download per year',
        ins240: '240 Ins Profiles to Download per year',
        insPackage50: '',
        insPackage100: '',
        insGiveAway500: '',
        insGiveAway200: '',
        pdf50: 'Convert 50 Emails per Month',
        pdfUnlimited: 'Unlimited Emails Conversions',
        threads2: '2 threads for data transfer',
        threads10: '10 threads for data transfer',
        scheduled: 'Scheduled transfer/sync/backup',
        // 第2组
        acrossClouds: 'Transfer/sync/backup across clouds',
        offline: 'Offline transfer/sync/backup',
        subAccounts3: 'Migrate 3 sub-accounts between team',
        subAccounts1000: 'Migrate 1000 sub-accounts between team',
        highSpeed: 'High-speed data transfer',
        // 第3组
        syncMode4: '4 one-way/two-way sync modes',
        syncMode10: '10 one-way/two-way sync modes',
        realSync: 'Real-time sync',
        passwordProtected: 'Password-protected sharing',
        subAccounts: 'Sub-accounts collaboration',
        // 第4组
        cloud30: '30+ leading cloud storage services',
        unlimitedCloud: 'Add unlimited cloud accounts',
        singleLog: 'Single log in to all clouds',
        support365: '24/7/365 priority support',
        // 其他
        unlimitedDataTraffic: 'Unlimited Cloud-to-cloud Data Traffic',
        unlimitedInsProfile: 'Unlimited Downloads of Ins Profiles',
        unlimitedAllFeatures: 'All Premium Features',
        // VIP弹窗标题
        vipPopupTitleTraffic: 'You have consume all data traffic',
        vipPopupDescTraffic: 'Upgrade to Unlock Unlimited data traffic',
        vipPopupTitleIns: 'You have consume all Downloads of Instagram Profiles ',
        vipPopupDescIns: 'Upgrade to Unlock Unlimited Downloads of Ins Profiles',
    },
    //套餐arguments参数翻译
    arguments: {
        //参数名
        title: {
            monthly100GB: '100GB / Month',
            monthly200GB: '200GB / Month',
            monthlyUnlimit: 'Unlimited Data / Month',
            yearly1200GB: '1200GB / Year',
            yearly2400GB: '2400GB / Year',
            yearlyUnlimit: 'Yearly Unlimited',
            lifetimeUnlimit: 'Lifetime Unlimited',
            package50GB: '50 GB',
            package100GB: '100 GB',
            giveAway500GB: '500GB / Year',
            giveAway200GB: '200GB / Year',
        },
        tips: {
            monthly100GB: 'E.g. You have only consumed 50GB of 100GB in the first month and you’ll still have 50GB of additional data traffic in the next month.',
            monthly200GB: 'E.g. You have only consumed 150GB of 200GB in the first month and you’ll still have 50GB of additional data traffic in the next month.',
            monthlyUnlimit: '',
            yearly1200GB: 'E.g. You have only consumed 1000GB of 1200GB in the first year and you’ll still have 200GB of additional data traffic in the next year.',
            yearly2400GB: 'E.g. You have only consumed 2000GB of 2400GB in the first year and you’ll still have 400GB of additional data traffic in the next year.',
            yearlyUnlimit: '',
            lifetimeUnlimit: '',
            package50GB: 'E.g. You have only consumed 20GB of 50GB this month, the unused 30GB will still remain in the next month',
            package100GB: 'E.g. You have only consumed 20GB of 100GB this month, the unused 80GB will still remain in the next month',
        }
    }
},
//双重验证功能
twoStepverification:{
    bind:'Bind Email First',
    addVerify:'You must add a way to verify.',
    phoneNotEmpty:'phone number can not be empty.',
    addPhone:'Add a phone number',
    addAlEmail:'Add an alternate email address',
    verifySet:'Verification Setting',
    addWayVerify:'Add a way to verify',
    enterEmail:'Enter your email',
    enterPhone:'Enter your phone number',
    enterCode:'Please enter the code we sent to',
    enterCodeTip:'Please check your junk mail folder and report not spam or add “no-reply@multcloud.email” to your White List.',
    codeExpired:'The verification code has expired.',
    codeinCorrect:'The verification code is incorrect, please check the code and try again.',
    verificationTurnOn:'Two-step verification is turned on',
    recoverAccess:'If you ever need to recover access to your account, this code will help. You should write it down and store it in a safe place. We strongly recommend that you don\'t store your recovery code on a device.',
    longValid:'If you previously had a recovery code, it is no longer valid. Use this new code instead.',
    removeAll:'Remove all devices?',
    lostAccess:'We recommend you do this if you\'ve lost access to a device you\'ve trusted.',
    removeMethod:'Remove Verification Method?',
    removeMethodSure:'Are you sure you want to remove the verification method? Removing it means that you will not be able to use it for verification.',
    getRecode:'Generate a new code',
    emailCode:'Email a code',
    TextCode:'Text a code',
    useAccount:'You are now using a temporary account,please bind email and try again.',
    removeTrusted:'Remove all trusted devices',
    finish:'Finish',
    newCode:'Your new code is',
    twoStep:'Two-step verification',
    twoStepis:'Two-step verification is',
    on:'On',
    off:'Off',
    cancel:'Cancel',
    toManyCodeSend:'Too many codes sent',
    verifyIdenti:'Verify identity with',
    codeCopied:'Code copied!',
    copyCode:'Copy Code',
    trustedDevice:'Trusted devices removed!',
    phoneValueTips:'Tips: Please remove the leading zero, and remove any spaces, dashes, or parentheses.',
},
website: {
    cloneNow: 'Clone Now',
    addTaskNow: 'Add Task and Clone Now',
    siteFromTitle: 'WEBSITE TO BACKUP',
    siteFromDesc: 'Click here to select the source Website data you\'d like to backup',
    siteToTitle: 'WHERE TO SAVE BACKUP',
    siteToDesc: 'Click here to select the cloud drive or folder you\'d like to transfer to',
    sourceServers: 'Source Servers',
    targetServers: 'Target Servers',
    desc: 'Back up your website files and database to the cloud, or migrate your website to a new host or domain.',
    addSite: 'Add Website Files',
    addSiteMore: 'Add More Website Files',
    removeSite: 'Remove Website Files',
    addDb: 'Add Database',
    addDbMore: 'Add More Website Database',
    removeDb: 'Remove Website Database',
    cloneSameNodeWarning: 'The source and destination of the clone cannot be the same node.',
    cloneTypeMismatchWarning: 'The source and destination types for the clone do not match.',
    clonePairExistsWarning: 'The same source and target combination already exists.',
    taskNameRequired: 'Please input task name',
    switchToPlusForWebsiteTasks: 'To view website backup tasks, you need to switch to MultCloud Plus.',
},
cloudBackup:{
    cloudBackup:'Cloud Backup',
    setUpCloud:'Set up a cloud backup task to backup online files from one cloud to another',
    filesBckupTarget: 'Target Directories',
    filesBckup:'FILES TO BACKUP',
    selectSoure:'Click here to select the source cloud files you\'d like to backup',
    saveBackup:'WHERE TO SAVE BACKUP',
    selectTarget:'Click here to select the target cloud to save the backup',
    backupNow:'Backup Now',
    canSelect:'You can select 10000 items at most',
    backupFiles:'You cannot backup your files to Google Photos.',
    notSelectEvernoteBackup: 'You cannot backup your files to Evernote.',
    backFlickr:'You cannot backup your files to Flickr.',
    thankSubscrib:'Thank you for subscribing our service, you now have maximum of 10 files backing up simultaneously.',
    maximunBack:'You now have a maximum of 2 files backing up simultaneously. Upgrade to any premium service to have a maximum of 10!',
    backSuccess:'Backup Success',
    backFailure:'Backup Failure',
    successBck:'Success in backing up all files',
    taskCanceled:'The task was manually canceled',
    notRestore:'Can’t find the files to restore. They may have already been deleted.',
    selectVersions:'Select versions',
    restoreOptions:'Restore options',
    selectFiles:'Select files you\'d like to restore.',
    toRestore:'Please select a file to restore.',
    originalLocation:'Original Location',
    thankRestore:'Thank you for subscribing our service, you now have maximum of 10 files restoring simultaneously.',
    restoreSimult:'You now have a maximum of 2 files restoring simultaneously. Upgrade to any premium service to have a maximum of 10!',
    restoreSuccess:'Restore Success',
    restorePartial:'Restore Partial Success',
    restoreFailure:'Restore Failure',
    notRestore:'Can’t find the files to restore. They may have already been deleted.',
    backupTime:'Backup Time',
    changedFiles:'Changed Files',
    deleteVersion:'Are you sure to delete the backup version?',
    deleteFiles:'Delete the files in this version',
    keepLatest:'Keep the latest file.',
    overWriteFile:'Overwrite the file.',
    skipFile:'Skip the file.',
    //2021-08-03添加
    versions:'Versions',
    backupTask:'Backup Task',
    readdCloud:'Re-add Cloud',
    selectedCloud:'Some of the selected clouds was added to MultCloud before Cloud Backup released, we suggest to re-add the clouds to MultCloud and try again.',
    continueAnyway:'Continue anyway',
    selectedHasAdded:'The selected cloud was added to MultCloud before Cloud Backup released, we suggest to re-add the cloud to MultCloud and try again.',
    failCreate:'Failed to create backup task.',
    failLoad:'Failed to load',
    pleaseReAdd:'please re-add the clouds to MultCloud.',
    alreadyAdd:'You’ve already added the cloud drive.',
    failRename:'Failed to rename, because can’t find the corresponding folder',
    taskRuning:'The task is running, please wait until the task ends and try again.',
    //2021-08-07添加
    oneBackup:'You can only perform one backup or restore task at the same time',
    restoreTask:'Restore Task',
    restoreOriginal:'Restore to original location',
    restoreNewLocation:'Restore to new location',
    //2021-08-12添加
    backingUp:'Backing up',
    restoring:'Restoring',
    restore:'Restore',
    backup:'Backup',
    //2021-08-17添加
    maxNum:'The maximum number of source intem is 1000, Please select less items. P.S. A whole folder only counts one item.',
    maxLogs:'Tips: The result is truncated. Up to 1,000 failed files are displayed here.',
    backupDetails:'Backup Details',
    keepTwoFile:'Keep two files.',
    restoreDetails:'Restore Details',
    longerDelete:'It may take longer if there is a large number of files to delete.',
    notFoundAim:'The target directory cannot be found.',
    //2021-10-20
    backupNotWork:'The backup service is not working',
    //2021-10-28
    backupPartial:'Backup Partial Success',
    configFile:'(Uploading configuration file)',
    //2021-11-16
    successRestore:'Success in restoring all files.',
    notFind:'Can\'t find the configuration file, please check if the configuration file exists and the connection between the cloud drive and MultCloud is valid.',
    selectRestoreItems:'Please select the files you\'d like to restore.',
    selectRestoreTotles:'Please select a directory to restore.',
    original: 'Original',
    inTotalTip: '{count} files,{size} in total',
},
affiliateProgram: {
    leftTitle: "Become our affiliate",
    title: "MultCloud Affiliate Program",
    headTips1: "Earn up to <span>50%</span> commission rate.",
    headTips2: "Sign up with a few clicks, abusolutely <span>free</span>.",
    headTips3: "No additional conditions, <span>anyone</span> can be our affiliate!",
    signUpBtn: "Sign up an affiliate account",
    tips: "Tips: If you're already an affiliate on Cleverbridge, please <a href=\"https://console.partnerize.com/campaigns/manage-campaigns/join-campaigns/advertiser-details/1011l331\" target=\"_blank\"> sign in </a>.",
    howDoTipsTitle: "How does it work",
    howDoTipsMsg: "Once you've signed up and logged in our affiliate program, you can find AOMEI International Network Limited under the \"Campaigns - Join Campaign\" tab. Click on it and confirm joining. Once you've joined our campaign, you'll see all MultCloud products available. If someone upgrades MultCloud via your referral link, you'll get paid with <span>30%-50%</span> commission rate.",
    FAQsTitle: "FAQs of MultCloud affiliate program",
    FAQ1: "How does affiliate program work?",
    answer1: "Once your customer has paid via your referral page, you’ll get your payout at the beginning of the next month.",
    FAQ2: "It sounds great. How do I sign up?",
    answer2: "You can sign up by clicking the \"Sign up an affiliate account\" above. Just a few steps, you'll have your affiliate account.",
    answerPs2: "Tips: Once you have sign in the console, you can find AOMEI International Network Limited under the \"Campains\" tab. Click on it and confirm joining.",
    FAQ3: "How much commission do I get?",
    answer3: "The commission differs from different subscription plans. For instance, the commission rate for Monthly plan is 30%, but for Life-time Unlimited plan, it will be 50%.",
    FAQ4: "How do I get paid?",
    answer4: "It depends on the “payment method” you’ve filled. You’ll always get paid at the beginning of each month.",
    answerPs4: "Tips: There is no minimum amount limit for each payout.",
    anyQuestionTitle: "Have any question?",
    anyQuestionTip: "Please be free to contact: <a href=\"mailto:affiliate@multcloud.com\" class=\"alink\">affiliate@multcloud.com</a>",
},
signUp: {
    pwdTip: "Password (8-16 characters)",
    signingUp: "Signing up . . .",
    tips2: "By creating an account, you accept the <a href=\"https://www.multcloud.com/terms\" class=\"alink\">Terms of Service <a/>&nbsp;and&nbsp;<a href=\"https://www.multcloud.com/policy\" class=\"alink\"> Privacy Policy<a/>.",
    emailPushTip: "By checking this box, you agree to receive emails from MultCloud regarding product, service updates, special offers and events. You may unsubscribe at any time.",
},
forgetPwd: {
    title: "Forgot Password?",
    tip: "Enter your email address and we'll send you a link to reset your password.",
    sending: "Sending the message ...",
    btnTxt: "Send Reset Email",
    tips1: "Forgot your email address?",
    tips2: " Send an email to support ",
    tips3: "and we'll track it down.",
},
balackFriday: {
    lastTip: "Hurry up, before it's gone",
    title: "Early access Black Friday and Cyber Monday to get UNLIMITED cloud-to-cloud data traffic with 70% OFF sale!",
    titleTip: "Hurry while our stock lasts!",
},
christmas: {
    payTxt: "Christmas Sale",
    popupTitle: "MULTCLOUD SUPER SALE",
    pageTitle: "Get UNLIMITED Cloud-to-Cloud Data Trafiic for Lifetime with {num}% OFF!",
    pageTitle2: "Get UNLIMITED Data Traffic for Lifetime with {num}% OFF!",
    paysysTitle: "HURRY UP, BEFORE IT'S GONE!",
    popupTip1: "UNLIMITED Cloud-to-cloud Data Traffic",
    popupTip2: "10 High-speed Data Transfer Threads",
    popupTip2Append: "There’re 10 transfer threads for premium users and 2 transfer threads for free users",
    popupTip3: "Scheduled Transfer/Sync/Backup",
    popupTip4: "One-way/Two-way Real Time Sync",
    popupTip4Append: "There’re 7 additional sync modes for premium users. Mirror sync supported",
    saledBtn: "SHOP NOW",
},
teamTransfer:{
    teamTransfer:'Team Transfer',
    transferMultiple:'Transfer multiple accounts from one cloud platform to another (Google Workspace, OneDrive for Business, Dropbox Business, Box for Business, Shared Drive).',
    businessCloud:'If you\'re an admin of business clouds, you can use this feature to easily migrate all accounts from one business cloud to another. For example, each user will have a folder of their own in a cloud platform, MultCloud can automatically pair the folders from two different business clouds and migrate the files from one cloud to another.',
    clickSelect:'Click here to select the source business cloud services you\'d like to transfer from.',
    sourceAccount:'Source Accounts',
    targetAccounts:'Target Accounts',
    autoMatch:'Auto-Match',
    likeTransfer:'Click here to select the target business cloud services you\'d like to transfer to.',
    youMust:'You must',
    cloudService:' add a business cloud service ',
    asAdmin:'as an admin first.',
    combinations:'Auto-Match will clean the current combinations, are you sure to continue?',
    nosourceAccount:'There is no source account or target account.',
    noAccount:'There are no accounts for Auto-Match.',
    uploadCSV:'Upload CSV',
    cleanCurrent :'Upload CSV will clean the current combinations, are you sure to continue?',
    csvFile:'The CSV file you upload should match the ',
    csvFormat:'.CSV format.',
    matchCsv:'The organization can’t match any combination from the CSV file, please check the CSV file and try again.',
    alreadyAdd:'You have already added the combination of these two accounts',
    cleanAll:'You are about to clean all the selected combinations, are you sure to continue?',
    sure:'Yes, I’m Sure',
    allTransferred:'Keep all transferred files in one folder.',
    optionActivated:'If this option is activated, all transferred files will be kept in one folder of the target cloud. For example, the source directory is Google Workspace\\simon@multcloud.com, and the target directory is OneDrive for Business\\peter@multcloud.com, all files in Google Workspace\\simon@multcloud.com will be transferred to OneDrive for Business\\peter@multcloud.com\\simon@multcloud.com when this option is activated.',
    organizationMigration:'Organization Migration',
    //jimin新增
    downloadCSV:'Download CSV',
    dontShow:'Don\'t show this again',
    notSelected:'Google Workspace shared drive cannot selected as the target cloud for team migration.',
    batchMatch:'Batch Match',
    sourceCloud:'Add Source Cloud',
    targetCloud:'Add Target Cloud',
    subTaskLimit:'Subtask Limit',
    freeUsers:'Free users can create 3 pairs of subtasks in a team transfer task, please upgrade to premium version and you can have 1000 subtasks in a team transfer task.',
    mostTeamTransfer:'3 subtasks in a team transfer',
    substasksMost:'1000 subtasks in a team transfer',
    mostTasks:'The number of subtasks can be 1000 at most.',
    timePassed:'The time you set has passed.'
},
shareTransfers: {
    logoMsg: '<span class="sf-logo-first">MultCloud</span><span class="sf-logo-name">Transfer</span>',
    addFiles: 'Add files from Clouds',
    trnsfering: 'Transferring …',
    sendingFile: 'Sending {num} file(s)',
    sendingSize: '{now} out of {all}',
    sendingTip: 'Creating transfer link, please wait.',
    cancelTransfer: 'Cancel this transfer?',
    createdTransfer: 'Transfer Created!',
    createShare: 'Create Transfer',
    signTitleByTransfer: 'Log in Multcloud to continue',
    signupTitleByTransfer: 'Sign up in Multcloud to continue',
    transferTitle: 'Title',
    transferDescription: 'Description',
    addFileTip: '{num} file(s) added',
    titleErrMsg: 'Title should be no more than 128 characters long.',
    desErrMsg: 'Description should be no more than 512 characters long.',
    folder: 'Folder',
},
summerSale: {
    titleTip: 'Hello Summer',
    titleTip2: 'Get UNLIMITED cloud-to-cloud data traffic and manage all your summer memories effortlessly at a sweet price!',
    bottomTip: '- BEST OFFER OF THE SEASON –',
},
halloweenSale: {
    titleTip2: 'Save up to 70% for No Tricks, Just Treat Yourself with Unlimited Cloud-to-cloud Data Traffic!',
    bottomTip: 'Hurry! Before it’s gone.',
},
newYear: {
    payTxt: "NEW YEAR SALE",
    titleTip: 'Ring in the New Year with a super 70% discount on UNLIMITED cloud-to-cloud data traffic!',
    bottomTip: 'Hurry! Before it’s gone.',
},
backToSchool: {
    titleTip2: 'Get UNLIMITED cloud-to-cloud data traffic and manage all your school memories at a sweet price!',
    bottomTip: '- BEST OFFER OF THE SEASON –',
},
blackFriday: {
    titleTip: 'Get 70% OFF on UNLIMITED cloud-to-cloud data traffic.',
    bottomTip: 'Hurry! Before it\'s gone.',
},
xmas: {
    titleTip: 'Enjoy a festive 70% discount on UNLIMITED cloud-to-cloud data traffic this Christmas!',
    bottomTip: 'Hurry! Before it’s gone.',
},
license: {
    codeTitle: 'Enter license',
    codeTipTitle: 'Enter License Code',
    codeTipText: 'If you have a license code, you can use it to activate the premium service.',
    codeTipTextVip: 'If you have a license code, you can use it to upgrade to a more advanced service.',
    codeFooter: 'If you need any help, please be free to contact: ',
    showTitle: 'License code',
    showTip: 'The license code is:',
    codeSucTitle: 'Premium Service Activated',
    codeSucTip: 'Premium Service Activated!',
},
filters: {
    taskList: {
        typeName: 'type',
        type: {
            all: 'All List',
            copy: 'Temp Tasks',
            transfer: 'Cloud Transfer',
            sync: 'Cloud Sync',
            backup: 'Cloud Backup',
            business: 'Team Transfer',
            remoteUpload: 'Remote Upload',
            emailMigration: 'Email Migration',
            restore: 'Cloud Restore',
        },
        statusName: "Status",
        status: {
            all: "All Status",
            preset: 'Preset',
            running: 'Running',
            success: 'Success',
            patial: 'Partial Success',
            failed: 'Failed',
            canceled: 'Canceled',
        },
        dateName: "Date",
        date: {
            all: 'All Time',
            today: 'Today',
            latestWeek: 'Latest Week',
            latestMonth: 'Latest Month',
            customDate: 'Custom Date',
        },
    }
},
schedule: {
    week1: "Sun",
    week2: "Mon",
    week3: "Tue",
    week4: "Web",
    week5: "Thu",
    week6: "Fri",
    week7: "Sat",
},
inputTab: {
    filterMessage: 'Press Enter to Add File Extension',
}
}



// WEBPACK FOOTER //
// ./src/assets/i18n/english.js